{
    "LOGIN": {
        "APP-NAME": "{{ appName }} Platform",
        "TITLE": "Login to {{ appName }} App",
        "ACCOUNT-PLACEHOLDER": "Account Name",
        "ACCOUNT-REQUIRED": "Account name is required",
        "ACCOUNT-SHORT": "Account name must consist of at least 2 characters.",
        "USERNAME-PLACEHOLDER": "Username",
        "USERNAME-REQUIRED": "Username is required",
        "USERNAME-SHORT": "Username must consist of at least 2 characters.",
        "PASSWORD-PLACEHOLDER": "Password",
        "PASSWORD-REQUIRED": "Password is required",
        "PASSWORD-SHORT": "Password must consist of at least 6 characters.",
        "REMEMBER-ACCOUNT-NAME": "Disable account name auto-fill",
        "FORGOT-PASSWORD": "FORGOT YOUR PASSWORD?",
        "LOGIN-BUTTON": "LOGIN",
        "BACK": "BACK",
        "SSO-BUTTON": "Sign in with SSO",
        "BEFORE-TERMS": "By clicking Login, you agree to our ",
        "TERMS": "Terms of Service",
        "CONJUNCTION": " and ",
        "PRIVACY": "Privacy Policy",
        "AFTER-PRIVACY": ".",
        "MORE-OPTIONS": "More Options",
        "ALTERNATIVE-CONN-MODE": "Alternative Connection Mode",
        "ALTERNATIVE-CONN-CAUTION": "Selecting this option helps optimize your connection in regions where internet access may be affected by local network conditions.",
        "VERIFICATION-CODE": "Verification Code",
        "VERIFICATION-SENDED": "We have sent you an email with a verification code.",
        "VERIFY-BUTTON": "VERIFY",
        "NO-INTERNET-ERROR": "No Internet. Please check your internet connection.",
        "USERNAME-PASSWORD-ERROR": "The username or password is wrong.",
        "INVALID-VERIFICATION-CODE": "Invalid two-step verification code",
        "ACCOUNT-DISABLED": "Your account has expired. Please contact {{ contactMail }}",
        "NO-WORKFLOW-LICENSE": "You don't have a workflow license. Please contact {{ contactMail }}",
        "UNKNOWN-ERROR": "An error occurred while signing in.",
        "LINK-ID-MISSING": "Link id is missing",
        "INTERNAL-ERROR": "Unknown error",
        "ID-OR-NAME-MISSING": "Link id or name is missing",
        "GUEST-PASSWORD-WRONG": "Workflow password is wrong"
    },
    "USER_PASSWORD": {
        "INVITE_TITLE": "Set your password",
        "RESET_TITLE": "Reset your password",
        "DESCRIPTION": "Create a new password for {{ username }}.",
        "PASSWORD": "Password",
        "CONFIRM_PASSWORD": "Confirm password",
        "REQUIRED": "This field is required.",
        "MIN_LENGTH": "Password must contain at least 6 characters.",
        "REQUIREMENTS_TITLE": "Password requirements:",
        "RULE_MIN_LENGTH": "At least {{ min }} characters",
        "RULE_MAX_LENGTH": "At most {{ max }} characters",
        "RULE_UPPERCASE": "At least one uppercase letter (A-Z)",
        "RULE_LOWERCASE": "At least one lowercase letter (a-z)",
        "RULE_NUMBER": "At least one number (0-9)",
        "RULE_SPECIAL": "At least one special character (e.g. ! @ # $ % & * ?)",
        "RULE_NO_SPACES": "No spaces",
        "RULE_NOT_COMMON": "Not a common password",
        "MISMATCH": "Passwords do not match.",
        "SUBMIT": "Continue",
        "SUCCESS": "Password saved successfully.",
        "INVALID_PASSWORD": "Password does not meet the requirements.",
        "LINK_INVALID_TITLE": "Link is not available",
        "LINK_INVALID": "This link is invalid, expired, or has already been used.",
        "LINK_INVALID_STATE": "This link no longer matches the current user state. A new invite or reset link is required.",
        "LINK_EXPIRED": "This link has expired.",
        "LINK_ALREADY_USED": "This link has already been used.",
        "LINK_SUPERSEDED": "A newer invitation or reset link has already been created. Please use the latest email.",
        "BACK_TO_LOGIN": "Back to login"
    },
    "MAIN": {
        "CONTENT": {
            "DASHBOARD": {
                "NO-WORKFLOW-FOR-NORMAL-USERS": "Empty List",
                "NO-WORKFLOW": {
                    "TITLE": "Workflow",
                    "TEXT": "Would you like to know how to simplify your work processes, eliminate paperwork and reduce administrative tasks? Our software solution is a unified, single software solution for work process management that will reduce the complexity of managing human resources and work processes. This software solution can be customized to your specific needs and it is a scalable technology.",
                    "CREATE": "Create a Workflow"
                },
                "AI-IN-PROGRESS": "AI in progress...",
                "TITLE": "Workflows",
                "CREATE": "Create Workflow",
                "GENERATE": "Create Workflow with AI",
                "WORKFLOW-TABLE": {
                    "NAME": "Name",
                    "VERSION": "Version",
                    "CREATED-BY": "Created by",
                    "STATUS": {
                        "TITLE": "Status",
                        "PUBLISHED": "Published",
                        "DRAFT": "Draft",
                        "INCOMPLETE": "Incomplete"
                    },
                    "ACTIONS": {
                        "TITLE": "Actions",
                        "OPTIONS": {
                            "TITLE": "Options",
                            "EDIT": "Edit Draft",
                            "USERS": "Users",
                            "EASY-GUEST-ACCESS": "Easy Guest Access",
                            "SHARING": "Sharing",
                            "PUBLISH": "Publish Draft",
                            "PUBLISH-VIEW": "View Published",
                            "DUPLICATE": "Duplicate Workflow",
                            "DELETE": "Delete Workflow",
                            "MOVE-TO-FOLDER": "Move to folder"
                        },
                        "PREFILLED-OPTIONS": {
                            "EDIT": "Edit",
                            "SHOW-QR": "Show QR",
                            "DUPLICATE": "Duplicate",
                            "DELETE": "Delete"
                        },
                        "SUBMITTED-OPTIONS": {
                            "SHOW-REPORT": "View Report",
                            "CHANGE-PREFILLED": "Change to prefilled"
                        }
                    },
                    "START": "START",
                    "LAST-EDITED": "Last Edited",
                    "PUBLISHED-AT": "Published at",
                    "LANGUAGES": "Languages",
                    "CONTENT-LANGUAGE": "CONTENT LANGUAGE",
                    "FILTER": {
                        "FILTER-BY": "Filter by",
                        "SELECT-LABEL": "Select label",
                        "SELECTED-LABELS": "Selected Labels",
                        "SELECT-STATUS": "Select Status",
                        "SELECTED-STATUSES": "Selected Statuses",
                        "CLEAR-ALL": "Clear all",
                        "EWERS-SEARCH-PLACEHOLDER": "Search by Tag-ID",
                        "EWERS-ID-LABEL": "Auftrags-Nr. / Serien-Nr."
                    },
                    "MANAGE-WORKFLOWS": "Manage workflows"
                },
                "TABS": {
                    "MY-WORKFLOWS": "My workflows",
                    "SUBMITTED-WORKFLOWS": "Submitted workflows",
                    "SHARED-WORKFLOWS": "Shared Workflows",
                    "SHARED-WORKFLOW": "Shared Workflow"
                },
                "VIEW-MODES": {
                    "LIST": "List",
                    "FOLDER": "Folder"
                },
                "FOLDER": {
                    "MOVE-TO-FOLDER": "Move to Folder",
                    "SELECTED": "selected",
                    "CREATE-FOLDER": "CREATE NEW FOLDER",
                    "NOT-FOLDERED": "Not Foldered",
                    "DELETE-FOLDER": "Delete Folder",
                    "NO-WORKFLOW-FOUND": "No workflows found.",
                    "EDIT-FOLDER": "Edit Folder",
                    "MOVE-TO": "Move to",
                    "FOLDER-NAME": "Folder name",
                    "CREATE": "Create",
                    "FOLDERS": "Folders",
                    "FOLDER-NAME-UNIQUE-ERROR": "Folder name must be unique",
                    "DELETE-FOLDER-WARNING-TEXT": "Are you sure you want to delete folder?",
                    "DELETE-FOLDER-INFO-TEXT": "Deleting this folder will not delete its contained workflows; they will be moved to \"Not Foldered\"."
                },
                "SEARCH": {
                    "TITLE": "Advanced Search",
                    "PLACEHOLDER": "Enter search query...",
                    "BUTTON": "Search",
                    "CANCEL": "Cancel",
                    "CLEAR": "Clear Search",
                    "RESULTS": "Search Results",
                    "NO_RESULTS": "No workflows found for your search query.",
                    "ERROR": "Search failed. Please try again.",
                    "APPLIED": "Search applied"
                },
                "TEXT-MESSAGE": "Your changes will be discarded. Do you want to delete this workflow?",
                "TEXT-MESSAGE-PUBLISH-VIEW": "You will switch to the editor mode. There, you can make changes on the last updated draft.",
                "TEXT-MESSAGE-UNSAVED-CHANGES": "There are unsaved changes.They will be saved and published.",
                "TEXT-MESSAGE-CLOSE-WORKFLOW": "Are you sure you want to close this workflow. Your changes will be discarded.",
                "TEXT-MESSAGE-CONDITIONAL-WORKFLOW": "The workflow you are trying to open is a conditional workflow. Our web version does not support it yet.",
                "TEXT-MESSAGE-PREFILLED-EDIT": "When you edit, a new qr and link will need to be generated. Previous QR code and link will be invalid",
                "TEXT-MESSAGE-PREFILLED-EDIT-TITLE": "Edit Prefilled Workflow",
                "CANCEL": "CANCEL",
                "CLOSE": "CLOSE",
                "EXPORT-WORKFLOWS": "EXPORT WORKFLOWS",
                "SAVE-AS-DRAFT": "Save as a Draft",
                "CONTINUE": "Continue",
                "UPDATE": "Update",
                "CONTINUE-UPPERCASE": "CONTINUE",
                "START-OVER": "START OVER",
                "WORKFLOW-STARTED": "You started this workflow already. Do you want to continue, or start a new one?",
                "NEW-VERSION": "This workflow can not be opened. You have to publish new version of Workflow",
                "ANOTHER-COPY": "A copy of this workflow will be created as version 1 in draft state, named with a \"(Copy)\" suffix. All of its steps, fields and files are copied too.",
                "DUPLICATE-SUCCESSFUL": "Workflow copied successfully.",
                "DUPLICATE-NESTED-SKIPPED": "Nested workflow links were not copied.",
                "DUPLICATE-FILES-FAILED": "{{count}} file(s) could not be copied. The copy still points to the original files.",
                "DUPLICATE-PARTIAL": "The copy was created, but copying its files did not finish. Open the copy and check its media.",
                "DUPLICATE-ERROR": "This workflow cannot be copied.",
                "DELETE-SUCCESSFUL": "Delete operation is Successful",
                "DELETE-ERROR": "Delete Error",
                "WORKFLOW-NOT-FOUND": "Workflow not found",
                "CREATION-LIMIT": "Workflow creation limit reached",
                "PUBLISH-SUCCESSFUL": "Publish is Successful",
                "PUBLISH-ERROR": "Publish Error",
                "EXPORT-CANCELED": "Export canceled",
                "EXPORT-FOLDER": "Export folder exists",
                "EXPORT-SUCCESSFUL": "Export is successful",
                "YES": "YES",
                "DELETE-REPORT-TITLE": "Delete Report",
                "DELETE-REPORT-TEXT": "Are you sure you want to delete this report?",
                "SAVE-PREFILLED-TITLE" : "Save Changes",
                "SAVE-PREFILLED-TEXT" : "Your changes will be saved. Are you sure you want to continue?",
                "CONNECTED-WORKFLOW-WARNING-TEXT": "This workflow cannot be deleted because it is connected to another workflow. You must first remove it from the connected workflow.",
                "SUBMITTED-REPORT-TO-PREFILLED-TEXT": "Are you sure you want to change this report as a prefilled?",
                "SUBMITTED-REPORT-TO-PREFILLED-TITLE": "Change Report Status",
                "NESTED-WORKFLOWS-CONNECTION-ENABLE-WARNING": "There is a connection in the workflow you added. Therefore, the connection will be activated in your current workflow. After saving your workflow, check the connections page."
            },
            "REMOTE": {
                "IMAGE-COLLABORATION": {
                    "UNDO": "Undo",
                    "REDO": "Redo",
                    "ANNOTATE": "Annotate",
                    "REVERT": "Revert",
                    "ZOOM-IN": "Zoom In",
                    "ZOOM-OUT": "Zoom Out",
                    "UP": "Up",
                    "DOWN": "Down",
                    "LEFT": "Left",
                    "RIGHT": "Right"
                }
            },
            "REPORT": {
                "NAME": "Name",
                "DESCRIPTION": "Description",
                "STEPS-COMPLETED": "Steps Completed",
                "START": "Started at",
                "END": "Ended at",
                "DURATION": "Duration",
                "EXPORT": "Export as CSV",
                "SUBMITTED-BY":"Submitted By",
                "PREFILLED-BY": "Prefilled By",
                "PREFILLED-AT": "Prefilled at",
                "QR-SCANNED-AT": "QR Scanned at",
                "SAVE-PDF": "Save as PDF",
                "STEP-LIST": {
                    "NAME": "Task name",
                    "CONTENT": "Content",
                    "DURATION": "Duration",
                    "NO-CONTENT": "N/A",
                    "DETECTED": "Detected",
                    "NOT-DETECTED": "Not Detected",
                    "MATCHED": "Matched",
                    "NOT-MATCHED": "Not Matched",
                    "ENTERED-VALUE": "Entered Value",
                    "SCANNED-VALUE": "Scanned Value"
                },
                "FILES": "Files",
                "OPTIONS": "Options",
                "APPROVAL": {
                    "TITLE": "Approval",
                    "DESCRIPTION-TEXT": "To give approval to this report, please e-sign below.",
                    "SIGN": "SIGN",
                    "RESEND": "Resend Approval Request",
                    "NOT-SIGNED": "NOT SIGNED",
                    "DELETE-APPROVAL": "Are you sure you want to delete?",
                    "DELETE": "Delete"
                },
                "SELECT-LANGUAGE": "Select Language",
                "MISSING-PARAMETERS": "There are missing parameters",
                "INVALID-TOKEN": "Invalid Token",
                "REPORT-NOT-FOUND": "Report is not found",
                "SUCCESSFULLY-SENDED": "Succesfully Sended",
                "REMOTE-CALL": {
                    "TITLE": "Remote Calls",
                    "STATUS": "Status",
                    "STEP": "Step",
                    "USERS": "Users",
                    "GUEST": "Guest",
                    "CALL-FAILED": "Call not started",
                    "CREATED-AT": "Created at"
                },
                "LOADING": "Loading..."
            },
            "REPORT-LIST": {
                "NO-REPORT": {
                    "TITLE": "Workflow Report",
                    "TEXT": "There is no report.",
                    "NO-REPORT-FOUND": "No report found associated with the given link id"
                },
                "TITLE": "Reports",
                "PLACEHOLDER": "Search by name",
                "LIST": {
                    "WORKFLOW": "Workflow",
                    "VERSION": "Version",
                    "SUBMITTED-BY": "Submitted By",
                    "SUBMITTED-TITLE": "Submitted",
                    "SUBMITTED": "Submitted",
                    "APPROVAL": "Approval",
                    "APPROVED": "Approved",
                    "PENDING": "Pending",
                    "VIEW": "View",
                    "PREFILLED": "Prefilled"
                },
                "LAST-SAVED": "Last Saved",
                "PERMISSION-ERROR": "You do not have permission to see the reports",
                "ERROR": "ERROR",
                "IMPORT-CANCELED": "Import canceled",
                "REPORT-FORMAT-WRONG": "Report format is wrong",
                "IMPORT-SUCCESSFUL": "Import is successful",
                "FILTER-ID": "Search by Tag-ID",
                "ID-TAG": "Tag-ID",
                "IMPORT_REPORTS": "IMPORT REPORTS",
                "WORKFLOW_REPORTS": "Workflow Reports",
                "REMOTE_SESSIONS": "Remote Sessions",
                "OPTIONS": "Options"
            },
            "USER-DETAIL": {
                "CREATE_TITLE": "Create User",
                "INVITE_TITLE": "Invite User",
                "EDIT_TITLE": "Edit User",
                "EDIT_DETAILS": "Edit User Details",
                "NAME": "Name",
                "NAME_REQUIRED": "Name is required",
                "NAME_PATTERN": "The name can only contain letters, numbers, underscores ( _ ) and hyphens ( - ).",
                "USERNAME": "Username",
                "USERNAME_REQUIRED": "Username is required",
                "USERNAME_PATTERN": "The username can only contain letters, numbers, underscores ( _ ) and hyphens ( - ).",
                "USERNAME_EXISTS": "This username does already exist.",
                "EMAIL": "Email",
                "EMAIL_REQUIRED": "Email is required",
                "INVALID_EMAIL": "Invalid email format",
                "SAVE_CHANGES": "SAVE CHANGES",
                "DELETE_USER": "DELETE USER",
                "CHANGE_PASSWORD": "Change Password",
                "CREATE_PASSWORD": "Create Password",
                "NEW_PASSWORD": "New Password",
                "CONFIRM_NEW_PASSWORD": "Confirm New Password",
                "SUBMIT_NEW_PASSWORD": "CHANGE PASSWORD",
                "PASSWORD_REQUIRED": "Password is required",
                "PASSWORD_REQUIREMENTS": "This password does not meet the requirements below.",
                "CONFIRM_PASSWORD": "Confirm Password",
                "CONFIRM_REQUIRED": "Password confirmation is required",
                "PASSWORD_MATCH": "Passwords do not match",
                "PASSWORD_MUST": "Password must:",
                "MIN_LENGTH": "consist of at least {{ minPasswordLength }} characters ",
                "UPPERCASE": "contain at least one uppercase (A-Z) ",
                "LOWERCASE": "contain at least one lowercase (a-z) ",
                "NUMBER": "contain at least one number (0-9) ",
                "SPECIAL": "contain at least one special character (-*/?#&()) ",
                "SUBMIT": "CREATE USER",
                "QR_CODE": "QR Code",
                "AUTHENTICATE": "You can authenticate smart glasses and mobile phones with your QR code.",
                "GENERATE_QR_CODE": "GENERATE QR",
                "REGENERATE_QR_CODE": "Regenerate Code",
                "DOWNLOAD": "DOWNLOAD",
                "DELETE": "DELETE",
                "LIMIT-WARNING": "This user will be created, but will not be a licensed workflow user, as you already reached your limit.",
                "DELETE-USER-OR-NOT": "Are you sure you want to delete this user?",
                "DELETE-QR-OR-NOT": "Are you sure you want to delete this QR code?",
                "CREATED-SUCCESSFULLY": "User created succesfully.But your workflow user limit is full. This user is not a workflow user",
                "INVITE-SENT": "User created and invitation email sent.",
                "INVITE-RESENT": "Invitation email sent again.",
                "SEND_INVITE": "Send Invite",
                "RESET-SENT": "Password reset email sent.",
                "RESEND_INVITE": "Resend Invite",
                "RESET_PASSWORD_EMAIL": "Send Password Reset Email",
                "RESET_PASSWORD_EMAIL_REQUIRED": "User email should be set first.",
                "ROLE": "Role",
                "MORE_SETTINGS": "More Settings",
                "EDITOR-ACCESS": "Editor Access",
                "EDITOR-ACCESS-TEXT": "The user will be given access to the editor so that the user can create and edit workflows.",
                    "REMOTE-ASSISTANCE": "Remote Assistance Settings",
                "WEAK-PASSWORD-WARNING": "Do not create weak passwords like '123456'"
            },
            "USER-LIST": {
                "TITLE": "Users",
                "CREATE": "CREATE USER",
                "CREATE-TEAM": "CREATE TEAM",
                "CREATE-WORK-GROUP": "Create Work Group",
                "WORK-GROUPS": "Work Groups",
                "SIMPLIFY": "Would you like to know, how to simplify your work processes, eliminate paperwork and reduce administrative tasks? Our software solution is a unified, single software solution for work process management that will reduce the complexity of managing human resources and work processes. This software solution can be customized to your specific needs and it is a scalable technology.",
                "LICENSED": "Licensed Workflow Users: ",
                "LICENSED-EXPERT": "Licensed Expert Users: ",
                "SEARCH": "Search",
                "UNLIMITED": "Unlimited",
                "USER-ACTIVATED": "user activated",
                "LIMIT-EXCEEDED": "! Limit exceeded",
                "LIST": {
                    "WORKFLOW-USER": "Workflow User",
                    "NAME": "Name",
                    "USERNAME": "Username",
                    "MEMBERS": "Members"
                },
                "SAMPLE": {
                    "TEAM-NAME": "Marketing",
                    "MEMBER-COUNT": "10 Members"
                },
                "ACTIONS": {
                    "OPTIONS": "Options",
                    "EDIT": "Edit",
                    "DELETE": "Delete"
                },
                "LICENCE-LIMIT": "Your account has reached the maximum number of workflow submissions. Please upgrade your license to see the newest workflow submissions.",
                "DEACTIVATE": {
                    "DEACTIVATED": "user deactivated",
                    "SAVE": "Save",
                    "CANCEL": "Cancel"
                },
                "CHANGES-WARNING": "There are unsaved changes. Are you sure you want to close without saving?",
                "DELETE-OR-NOT": "Are you sure you want to delete this user?",
                "SAVE-SUCCESSFUL": "Save Successful",
                "LIMIT-EXCEED": "Limit exceed.",
                "ERROR": "Error",
                "INVITE_PENDING": "Pending",
                "USERS-AND-TEAMS": "Users & Teams",
                "TEAMS": "Teams",
                "TEAM": "Team"
            },
            "WORKFLOW": {
                "REQUIRED": "Required Field",
                "SIDEBAR": {
                    "DETAILS": "Details",
                    "EDITOR": "Editor",
                    "CONNECTIONS": "Connections"
                },
                "WORKFLOW-DETAIL": {
                    "TITLE": "Details",
                    "NAME": {
                        "TITLE": "Name",
                        "REQUIRED": "required",
                        "NO-NAME": "This field is required."
                    },
                    "DESCRIPTION": "Description",
                    "DURATION": "Estimated Duration",
                    "LABEL": {
                        "TITLE": "Labels",
                        "CREATE": "Create new",
                        "NO-ITEMS-FOUND": "No items found"
                    },
                    "SHOW-CONTENT-PAGE": "Show Content Page",
                    "UPLOAD-FILE": "Upload File",
                    "PREVIEW-TEXT": "To edit the workflow, go to the Editor tab.",
                    "UPLOAD-FILE-INFO": "You can upload files containing information about that workflow. Currently, only pdf files are support.",
                    "CONNECTION-WARNING": "“Content Page” cannot be enabled, because Connections are activated.",
                    "DELETE-FILE": "Are you sure to delete this file?",
                    "REMOTE-CALL-EXPERTS": "Remote Call with Expert"
                },
                "WORKFLOW-STEPS": {
                    "STEP-LIST": {
                        "INFORM": "Create a new step with the button below.",
                        "STEP": {
                            "NO-NAME": "Step name is required",
                            "OPTIONS": {
                                "RENAME": "Rename",
                                "DUPLICATE": "Duplicate",
                                "DELETE": "Delete",
                                "MOVE": "Move",
                                "CLONE": "Clone",
                                "CLONE-STEP": "Clone Step",
                                "MOVE-STEP": "Move Step"
                            },
                            "CREATE": "Create New Step",
                            "ADD-STEP": "Add Step"
                        },
                        "MANAGE-STEPS": {
                            "TITLE": "Manage Steps",
                            "DELETE": "Delete",
                            "DUPLICATE": "Duplicate",
                            "CLONE": "Clone",
                            "MOVE": "Move",
                            "SELECT-ALL": "Select All",
                            "DESELECT-ALL": "Deselect All",
                            "CONNECTION-VIEW-DISABLED": "Disabled because of connection view"
                        },
                        "TEXT-MESSAGE": "Your changes will be discarded. Do you want to delete the steps you added?",
                        "CLONE-TEXT-MESSAGE": "The step you selected will be copied to the selected workflow.",
                        "MOVE-TEXT-MESSAGE": "The step you selected will be moved to the selected workflow and will be deleted from this workflow.",
                        "SELECT": "Select",
                        "CREATE-SECTION": "Create Section",
                        "SECTION-TEXT-MESSAGE": "There is no section in this workflow. Upon creating a section, previously created steps will be added to it. Do you want to continue?",
                        "SECTION-DELETE-TEXT-MESSAGE": "This section and steps under section will be removed.If there are steps you don't want deleted, you can move them before deleting.",
                        "INDEPENDENT": "Steps cannot be independent from section",
                        "DELETE-STEP": "Selected steps will be deleted. Are you sure you want to delete the steps below?",
                        "INITIAL-STEP-WARNING-MESSAGE": "The selected step is the initial step of the workflow. You have to change the initial step before deleting.",
                        "CONNECTED-STEPS-WARNING-MESSAGE": "There are connected steps with this steps. If you delete this step your connections will be gone. Please check your connections on the connections page."
                    },
                    "STEP-PREVIEW": {
                        "NO-STEP": "Not Selected"
                    },
                    "WIDGET-PROPERTIES": {
                        "EMPTY": "Click here to add content",
                        "INFORM": "On the step preview you can see how your content will be displayed to the user.",
                        "BACK": "Back",
                        "POSITION": {
                            "TITLE": "Position",
                            "HORIZONTAL": "Horizontal Position",
                            "VERTICAL": "Vertical Position"
                        },
                        "LABEL": {
                            "TITLE": "Title",
                            "REQUIRED": "required",
                            "NO-LABEL": "Label is required"
                        },
                        "PLACEHOLDER": "Placeholder",
                        "OPTIONS": {
                            "TITLE": "Options",
                            "NO-LABEL": "Label is required",
                            "MUST-UNIQUE": "Option labels must be unique",
                            "DELETE-LAST": "- Last item cannot be deleted",
                            "ADD": "Add Option",
                            "MAX-ADDED": "Adding a large number of elements may require scrolling on smart glasses."
                        },
                        "NUMBER-FIELDS": {
                            "MIN": "Min",
                            "MAX": "Max",
                            "UNIT": "Unit",
                            "PRECISION": "Precision"
                        },
                        "PPE-FIELDS": {
                            "TITLE": "Detect the following equipment:",
                            "FACE": "Face cover",
                            "HEAD": "Head cover",
                            "HAND": "Hand cover",
                            "NO-RECOGNITION": "Select at least one PPE recognition."
                        },
                        "TIME-PICKER": "Date includes time",
                        "QR-FIELD": "QR code value",
                        "QR-ACTIVATION": "Activate QR Validation",
                        "QR-FIELD-VALIDATION-TEXT": "QR field is required.",
                        "QR-ACTIVATION-INFO-TEXT": "When QR validation is enabled, the QR code value (QR link) you provide will be compared to the QR code scanned by the user to determine if they match.",
                        "REQUIRED": {
                            "TEXT": "Make this field required",
                            "INFORM": "Activate this button, if you want to make sure that this step cannot be skipped by the user."
                        },
                        "IMAGE": {
                            "TITLE": "Upload Image",
                            "REQUIRED": "required",
                            "UPLOAD": {
                                "DRAG-DROP": "Drag & Drop",
                                "INFORM": "Drag files or click here to upload",
                                "CLICK": {
                                    "UPLOAD": "Upload Image",
                                    "CHANGE": "Change Image",
                                    "EDIT": "Edit Image"
                                }
                            },
                            "NO-IMAGE": "Image is required"
                        },
                        "GALLERY": {
                            "TITLE": "Upload Images",
                            "REQUIRED": "required",
                            "NO-IMAGE": "Image is required",
                            "DELETE-IMAGE-TEXT-MESSAGE": "Are you sure you want to delete this image?",
                            "VALIDATION-TEXT": "You can upload maximum 50 images.",
                            "DELETE-IMAGE": "Delete Image"
                        },
                        "VIDEO": {
                            "TITLE": "Upload Video",
                            "REQUIRED": "required",
                            "UPLOAD": {
                                "DRAG-DROP": "Drag & Drop",
                                "INFORM": "Drag files or click here to upload",
                                "CLICK": {
                                    "UPLOAD": "Upload Video",
                                    "CHANGE": "Change Video"
                                }
                            },
                            "NO-IMAGE": "Video is required"
                        },
                        "PDF": {
                            "TITLE": "Upload PDF",
                            "REQUIRED": "required",
                            "UPLOAD": {
                                "DRAG-DROP": "Drag & Drop",
                                "INFORM": "Drag files or click here to upload",
                                "CLICK": {
                                    "UPLOAD": "Upload PDF",
                                    "CHANGE": "Change PDF"
                                }
                            },
                            "NO-IMAGE": "PDF is required"
                        },
                        "TABLE": {
                            "CREATE-TABLE": "Create Table",
                            "COLUMN": "Column",
                            "ROW": "Row",
                            "CREATE": "Create",
                            "ADD-ROW": "Add Row",
                            "DELETE-ROW": "Delete Row",
                            "ADD-COLUMN": "Add Column",
                            "DELETE-COLUMN": "Delete Column",
                            "SELECT-CELL-TEXT": "To fill the table please select a cell",
                            "SELECT-CONTENT-TYPE-TEXT": "Select content type",
                            "SELECTED": "Selected Cell : ",
                            "COLUMN-VALIDATION-TEXT": "Columns should be at least 1.",
                            "ROW-VALIDATION-TEXT": "Rows should be at least 1.",
                            "CLEAR": "Clear content",
                            "HEADER-CELL-INFO": "Header cells can only contain column names",
                            "Label": "Label",
                            "Input": "Text Input",
                            "Number": "Number Input",
                            "Datepicker": "Date Picker",
                            "Checkbox": "Checkbox",
                            "Radio": "Radio Button"
                        },
                        "TEXT-MESSAGE": "Are you sure you want to replace the widget?",
                        "DELETE-TEXT-MESSAGE": "Are you sure you want to delete the widget?",
                        "TITLE-DELETE": "Delete Widget",
                        "TITLE-CHANGE": "Replace Widget",
                        "REPLACE": "Replace",
                        "DELETE-ROW-TEXT-MESSAGE": "Are you sure you want to delete the row?",
                        "DELETE-COLUMN-TEXT-MESSAGE": "Are you sure you want to delete the column?",
                        "TITLE-DELETE-ROW": "Delete Row",
                        "TITLE-DELETE-COLUMN": "Delete Column",
                        "CONNECTION-WARNING-TEXT-MESSAGE": "You can not change this widget. Because a it is connected to a condition.",
                        "CONNECTION-WARNING-HEADER": "Connection Alert",
                        "WIDGET-TITLES": {
                            "LABEL": "Label",
                            "TEXT-INPUT": "Text Input",
                            "NUMBER-INPUT": "Number Input",
                            "DATE-PICKER": "Date Picker",
                            "CHECKBOX": "Checkbox",
                            "RADIO-BUTTON": "Radio Button",
                            "IMAGE": "Image",
                            "VIDEO": "Video",
                            "PDF": "PDF",
                            "DETECT-QR": "Detect QR",
                            "CAPTURE-IMAGE": "Capture Image",
                            "CAPTURE-VIDEO": "Capture Video",
                            "PPE": "PPE",
                            "VOICE-RECORD": "Voice Record",
                            "VOICE": "Voice",
                            "VSIGHT-REMOTE": "VSight Remote",
                            "AR-INSTRUCTION": "AR Instruction",
                            "HTML": "Rich Text",
                            "GALLERY": "Gallery",
                            "TABLE": "Table",
                            "FORM": "Form",
                            "WORKFLOW": "Workflow",
                            "ID": "Tag-ID",
                            "SIGNATURE": "Signature"
                        },
                        "WIDGET-DESCRIPTION": {
                            "INSTRUCTION": "Instruction",
                            "FEEDBACK": "Feedback",
                            "VISUAL-SUPPORT": "Live Support",
                            "AUGMENTED-REALITY": "Augmented Reality",
                            "VISUAL-AI": "Visual AI",
                            "COMING-SOON": "Coming Soon",
                            "FULLSCREEN": "Only available on full page"
                        },
                        "LIMIT-EXCEED": "Limit exceed. Max limit is 50."
                    },
                    "STEP-FILES": {
                        "TITLE": "Attach Files to Step",
                        "VIEW-STEP-FILES": "View files attached to step"
                    }
                },
                "TITLE": "Workflow",
                "APPROVE": "Approve",
                "CANCEL": "Cancel",
                "SAVE": "Save Draft",
                "PUBLISH": "Publish",
                "SAVE-PUBLISH": "Save & Publish",
                "EDIT-WORKFLOW": "EDIT WORKFLOW",
                "EDIT-WORKFLOW-TITLE": "Edit Workflow",
                "EDIT-MODE-TEXT-MESSAGE": "You are now in preview mode. Click on 'EDIT WORKFLOW' to make changes.",
                "STEP-PREVIEW": "Step preview",
                "WIDGET-PROPERTIES": "Select a layout from the step preview to add widgets.",
                "CONNECTIONS-PAGE": "Connections page",
                "CHANGE-STEP-LAYOUT": "Change step layout",
                "ERROR-MESSAGE": {
                    "MESSAGE": "You cannot switch to full page mode, unless one side of the layout is empty.",
                    "NOT-SUPPORT": "This widget is not supported in the selected layout.",
                    "CONFIRM": "Close"
                },
                "TEXT-MESSAGE": {
                    "MESSAGE": "Are you sure you want to close the editor? Unsaved changes will be discarded.",
                    "CONFIRM": "Close",
                    "OK": "OK",
                    "SWITCH-MODE-MESSAGE": "Are you sure you want to switch mode?"
                },
                "PREVIEW": {
                    "DETECT-QR": "Detect QR Code/Barcode",
                    "DETECT-PPE": "Detect a PPE from the Camera",
                    "PICK_IMAGE": "Pick an Image",
                    "PICK-VIDEO": "Pick a Video",
                    "CAPTURE-VIDEO": "Capture a Video",
                    "CAPTURE-IMAGE": "Capture an Image",
                    "DETECT-PPE-FROM-FINDER": "Pick a PPE Image",
                    "DETECT-QR-WITH-UPLOAD": "Pick a QR Code/Barcode",
                    "DETECT-QR-WITH-CAMERA": "Detect QR Code/Barcode",
                    "SIGN-HERE": "Sign here"
                },
                "WORKFLOW-CONNECTIONS": {
                    "CONDITIONS": "Conditions",
                    "ADD-CONDITION": "Add Condition",
                    "INFORM-TEXT": "Select a step to add a condition.",
                    "FROM": "From",
                    "TO": "To",
                    "DELETE-CONNECTION": "Delete connection",
                    "WHEN": "When",
                    "REQUIRED-FIELD": "Required field",
                    "ADD-LOGICAL-CONDITION": "Add Logical Condition",
                    "DELETE-CONDITION": "Delete Condition",
                    "CONDITION": "Condition",
                    "GO-TO": "Go To",
                    "ELSE-CONDITION-TEXT": "If no conditions apply, go to",
                    "NOT-SELECTED": "Not selected",
                    "TURN-ON-CONNECTIONS": "Turn on Connections",
                    "TURN-ON-CONNECTIONS-TEXT": "You can turn on \"Connections\" to create a conditional flow and edit connections between steps.",
                    "SELECT": "Select",
                    "ENTER": "Enter",
                    "CONTENT-PAGE-WARNING-TEXT": "Are you sure you want to turn on Connections?",
                    "CONTENT-PAGE-IMPORTANT-WARNING-TEXT": "CAUTION: Turning on Connections will permanently disable the “Content Page” feature in this workflow.",
                    "CONFIRM": "Yes",
                    "INITIAL-STEP-CHANGE-TEXT": "You can change the initial step by clicking here",
                    "INITIAL-STEP-CHANGE-WARNING-TEXT": "This step can not be initial step, because there are steps which are connected to selected step.",
                    "INVALID-DATA": "This step can not be autosaved because of invalid data.",
                    "ALREADY-CONNECTED": "You cannot create a connection between steps already connected."
                },
                "HEADER-TITLES": {
                    "CLOSE-WORKFLOW": "Close Workflow",
                    "PUBLISH-WORKFLOW": "Publish Workflow",
                    "DELETE-USER": "Delete User",
                    "DELETE-WORKFLOW": "Delete Workflow",
                    "WARNING": "Warning",
                    "DELETE-FILE": "Delete File",
                    "DELETE-SECTION": "Delete Section",
                    "DELETE-STEP": "Delete Step",
                    "LOGOUT": "Logout",
                    "LICENCE-WARNING": "License Warning",
                    "DUPLICATE-WORKFLOW": "Duplicate Workflow",
                    "SELECT-DEFAULT-LANGUAGE": "Select Default Language",
                    "SWITCH-MODE": "Switch Mode"
                },
                "LANGUAGE": {
                    "SEARCH": "Search",
                    "ADDED": "Added",
                    "DEFAULT": "Default",
                    "NOT-ADDED": "Not Added",
                    "LANGUAGE-INFO-TEXT": "Create a multi-language workflow for your users by adding a new language. You can also change the primary language you prefer your users to view the workflow in by setting it as default language.",
                    "SELECT-LANGUAGE": "Select Language",
                    "CHECK-LANGUAGE": "You made changes after auto-translate. Please do not forget to check all languages!",
                    "DELETE-LANGUAGE-OR-NOT": "Are you sure you want to delete language? All content in the selected language will be lost."
                },
                "DELETE": "Delete",
                "WORKFLOW-NOT-FOUND": "Workflow not found associated with the link",
                "SAVE-SUCCESSFUL": "Save is successful",
                "SAVE-ERROR": "Save Error",
                "CLONED": "Successfully Cloned",
                "REPORT-SUBMITTED-BEFORE": "Report has already been submitted"
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "Manage Public Access",
                "MANAGE-PUBLIC-ACCESS-TEXT": "You can stop sharing this workflow by deleting public access.",
                "GENEATE-ACCESS-TEXT": "You can generate a public link and QR code to create an easy access for this workflow.",
                "ENABLE-PASSWORD": "Enable password",
                "GENERATE-ACCESS": "Generate",
                "LINK": "Link",
                "COPY": "Copy",
                "QR-CODE": "QR Code",
                "DOWNLOAD": "Download",
                "SECURITY": "Security",
                "PASSWORD-PROTECTED": "Password-protected",
                "PUBLIC": "Public",
                "DELETE-ACCESS": "Delete Public Access",
                "EASY-ACCESS-TITLE": "{{ shortName }} Workflow Easy Access",
                "OPEN-WORKFLOW-NAME": "You are about to open",
                "GUEST-EMAIL": "Guest Email",
                "REQUIRED": "This field is required",
                "GUEST-PASSWORD": "Password for Guests",
                "OPEN": "OPEN",
                "OPEN-APP": "We suggest to open this workflow in our app for better experience.",
                "COPY-LINK-TEXT": "Copy link to clipboard to open this workflow when app is launched.",
                "DOWNLOAD-APP": "DOWNLOAD APP",
                "DOWNLOAD-SMARTGLASSES-APP": "DOWNLOAD APP FOR SMARTGLASSES",
                "OR": "OR",
                "CONTINUE-WITH-BROWSER": "Continue with browser",
                "PASSWORD-PROTECTED-TEXT": "When password is enabled, users that have the public link or QR code, can access this workflow only when entering the password.",
                "CREATE-PASSWORD": "Create Password",
                "ENTER-EMAIL": "Enter your email",
                "ENTER-WORKFLOW-PASSWORD": "Enter workflow's password",
                "DELETE-QR-TEXT": "To change security type of Easy Access, you should delete Easy Access and generate again.",
                "LOADING-WORKFLOW": "Loading workflow...",
                "UNABLE-TO-LOAD": "Unable to Load Workflow",
                "RETRY": "Retry",
                "GUEST-ACCESS": {
                  "TOKEN-MISSING": "Token missing or invalid",
                  "ID-MISSING": "Workflow id or base url is missing",
                  "WORKFLOW-NOT-PUBLISHED": "Workflow is not published",
                  "PUBLIC-ACCESS": "Public access already exist",
                  "NO-PUBLIC-ACCESS": "No public access"
                },
                "QR-INFORMATION": "QR Information"
            },
            "WORK-ORDERS": {
                "TITLE": "Work Orders",
                "CREATE-WORK-ORDER": "Create Work Order",
                "EDIT-WORK-ORDER": "Edit Work Order",
                "EDIT": "Edit",
                "CREATE": "Create",
                "DELETE": "Delete",
                "SAVE-CHANGES": "Save Changes",
                "TO-DO": "To Do",
                "DONE": "Done",
                "DETAILS": "Details",
                "COMMENTS": "Comments",
                "ASSIGNED-EXPERTS-FOR-REMOTE-CALL": "Assigned Experts for Remote Call",
                "EMPTY-LIST": "No work orders found.",
                "SELECT-PRIORITY": "Priority",
                "PRIORITY": {
                    "high": "High",
                    "medium": "Medium",
                    "low": "Low"
                },
                "SELECT-STATUS": "Status",
                "STATUS": {
                    "open": "Open",
                    "in-progress": "In Progress",
                    "on-hold": "On Hold",
                    "done": "Done"
                },
                "SELECT-ASSIGNEE": "Assignee",
                "SELECT-LABEL": "Label",
                "SEARCH": "Search",
                "NO-ITEMS-FOUND": "No items found",
                "SELECT-DUE-DATE": "Due Date",
                "SELECT-RECURRENCE": "Recurrence",
                "RECURRENCE": {
                    "none": "None",
                    "daily": "Daily",
                    "weekly": "Weekly",
                    "monthly": "Monthly"
                },
                "ITEMS": {
                    "ID": "ID",
                    "PRIORITY": "Priority",
                    "DUE-DATE": "Due Date",
                    "TASK-NAME": "Task Name",
                    "STATUS": "Status",
                    "ADD-DUE-TIME": "Add due time",
                    "CLEAR-DUE-TIME": "Clear time",
                    "RECURRENCE": "Recurrence",
                    "DESCRIPTION": "Description",
                    "FILES": "Files",
                    "ASSIGNED-WORKFLOWS": "Assigned Workflows",
                    "ADD-WORKFLOW": "Add Workflow",
                    "ASSIGNED-TO": "Assigned to",
                    "SELECT-USER": "Select user",
                    "ACTIVITY": "Activity"
                },
                "ACTIVITY": {
                    "dueDate": "due date",
                    "assignedTo": "assigned to",
                    "status": "status",
                    "priority": "priority",
                    "assignedExpert": "assigned expert",
                    "files": "files",
                    "labels": "labels",
                    "description": "description",
                    "name": "name",
                    "assignedWorkflows": "assigned workflows",
                    "recurrence": "recurrence",
                    "UPDATED": "updated the",
                    "WORK-ORDER-CREATED": "created the work order"
                },
                "WARNING": {
                    "DELETE-WORK-ORDER-TITLE": "Delete Work Order",
                    "DELETE-WORK-ORDER-TEXT": "Are you sure you want to delete this work order?",
                    "UNASSIGN-WORKFLOW-TITLE": "Unassign worklfow",
                    "UNASSIGN-WORKFLOW-TEXT": "Are you sure you want to unassign this worklfow?"
                }
            },
            "TICKETS": {
                "TITLE": "Tickets",
                "NEW_TICKET": "New Ticket",
                "CREATE_TICKET": "Create Ticket",
                "EDIT_TICKET": "Edit Ticket",
                "TICKET_DETAILS": "Ticket Details",
                "TICKET_CREATED": "Ticket created successfully",
                "TICKET_UPDATED": "Ticket updated successfully",
                "TICKET_DELETED": "Ticket deleted successfully",
                "DELETE_CONFIRM": "Are you sure you want to delete this ticket?",
                "ALL_ROOMS": "All Rooms",
                "ALL_CREATORS": "All Creators",
                "ALL_ASSIGNEES": "All Assignees",
                "ALL_STATUSES": "All Statuses",
                "ALL_PRIORITIES": "All Priorities",
                "CREATED_BETWEEN": "Created Between",
                "NO_TICKETS": "No tickets found",
                "TICKET_TITLE": "Title",
                "ROOM": "Room",
                "WORK_GROUP": "Work Group",
                "ALL_WORK_GROUPS": "All Work Groups",
                "CREATED_BY": "Created By",
                "CREATED_ON": "Created On",
                "STATUS": "Status",
                "STATUS_OPEN": "Open",
                "STATUS_IN_PROGRESS": "In Progress",
                "STATUS_CLOSED": "Closed",
                "STATUS_IN-PROGRESS": "In Progress",
                "STATUS_UPDATED": "Status updated successfully",
                "LOW": "Low",
                "MEDIUM": "Medium",
                "HIGH": "High",
                "PRIORITY_LOW": "Low",
                "PRIORITY_MEDIUM": "Medium",
                "PRIORITY_HIGH": "High",
                "TYPE": "Type",
                "PRIORITY": "Priority",
                "DESCRIPTION": "Description",
                "RESOLUTION": "Resolution",
                "FOLLOWUP_DATE": "Follow-up Date",
                "ASSIGNEE": "Assignee",
                "CREATE": "Create",
                "SAVE": "Save",
                "SAVE_CHANGES": "Save Changes",
                "CANCEL": "Cancel",
                "DELETE": "Delete",
                "DELETED": "Deleted successfully",
                "DELETE_ERROR": "Failed to delete ticket",
                "EDIT": "Edit",
                "TAB_ACTIVE": "Active",
                "TAB_CLOSED": "Closed",
                "UPDATE_SUCCESS": "Ticket updated successfully",
                "CREATE_SUCCESS": "Ticket created successfully",
                "UPDATE_ERROR": "Failed to update ticket",
                "CREATE_ERROR": "Failed to create ticket",
                "LOAD_ERROR": "Failed to load ticket details",
                "TITLE_REQUIRED": "Title is required",
                "DESCRIPTION_REQUIRED": "Description is required",
                "FORM_INVALID": "Please fill in all required fields",
                "DETAILS": "Details",
                "ATTACHED_SESSIONS": "Attached Sessions",
                "ADD_SESSION": "Add Session",
                "SESSION_COUNT": "Session Count",
                "TOTAL_DURATION": "Total Duration",
                "PARTICIPANTS": "Participants",
                "DATE": "Date",
                "ROOM_NAME": "Work Group",
                "DURATION": "Duration",
                "SESSIONS": "Sessions",
                "GUEST": "Guest",
                "NO_SESSIONS": "No sessions found",
                "NO_ATTACHED_SESSIONS": "No attached sessions",
                "DETACH_SESSION": "Detach Session",
                "DETACH_SESSION_CONFIRM": "Are you sure you want to detach this session from the ticket?",
                "DETACH": "Detach",
                "DETACH_SUCCESS": "Session detached successfully",
                "ATTACH_SUCCESS": "Ticket changed successfully",
                "SESSION_ALREADY_ATTACHED": "This session is already attached to another ticket",
                "WORK_GROUP_CHANGE_WARNING": "Change Work Group",
                "WORK_GROUP_CHANGE_CONFIRM": "This ticket has {{count}} attached session(s) from the current work group. If you change the work group, all these sessions will be automatically detached. Do you want to continue?",
                "WORK_GROUP_CHANGE_CONFIRM_SINGULAR": "This ticket has 1 attached session from the current work group. If you change the work group, this session will be automatically detached. Do you want to continue?",
                "FILES": {
                    "TITLE": "Files",
                    "DOWNLOAD": "Download",
                    "DOWNLOAD_STARTED": "Download started",
                    "NO_FILES": "No files found",
                    "UPLOAD_SUCCESS": "File uploaded successfully",
                    "UPLOAD_ERROR": "Failed to upload file"
                },
                "CHAT_TIMELINE": {
                    "TITLE": "Chat+Timeline",
                    "EMPTY": "No messages or activities yet",
                    "PLACEHOLDER": "Type a message... Use @ to mention users",
                    "SEND": "Send",
                    "SEND_ERROR": "Failed to send message",
                    "ATTACH_FILE": "Attach file",
                    "PASTE_UPLOAD_TITLE": "Upload file",
                    "PASTE_UPLOAD_CONFIRM": "Do you want to upload the file from clipboard?",
                    "PASTE_UPLOAD_CONFIRM_BUTTON": "Upload",
                    "SESSION_ATTACHED": "Remote session held",
                    "FILE_ADDED": "File added",
                    "UPLOADED_BY": "uploaded",
                    "TODAY": "Today",
                    "YESTERDAY": "Yesterday",
                    "SYSTEM": {
                        "DEFAULT_ACTOR": "A user",
                        "STATUS_CHANGED": "{{ actor }} changed status from {{ from }} to {{ to }}.",
                        "PRIORITY_CHANGED": "{{ actor }} changed priority from {{ from }} to {{ to }}.",
                        "DATE_CHANGED": "{{ actor }} changed date from {{ from }} to {{ to }}.",
                        "ASSIGNEE_CHANGED": "{{ actor }} changed assignee from {{ from }} to {{ to }}.",
                        "ROOM_CHANGED": "{{ actor }} changed room from {{ from }} to {{ to }}.",
                        "TYPE_CHANGED": "{{ actor }} changed type from {{ from }} to {{ to }}.",
                        "TITLE_UPDATED": "{{ actor }} updated the title.",
                        "DESCRIPTION_UPDATED": "{{ actor }} updated the description.",
                        "RESOLUTION_UPDATED": "{{ actor }} updated the resolution.",
                        "EXTRA_FIELDS_UPDATED": "{{ actor }} updated other fields."
                    }
                },
                "EXPORT_PDF": {
                    "BUTTON": "Export",
                    "TITLE": "Export Ticket",
                    "SUBTITLE": "Choose what to include in the report.",
                    "ATTACHED_SESSIONS": "Attached Sessions",
                    "FILES": "Files",
                    "CHAT": "Chat",
                    "IMAGES_IN_PDF": "Embed images inside PDF",
                    "IMAGES_OPTIMIZED": "Images are optimized for PDF size.",
                    "IMAGE_COMPRESSION_TOOLTIP": "Images may be compressed to optimize file size.",
                    "SECTION_INCLUDE": "INCLUDE",
                    "SECTION_OUTPUT": "OUTPUT",
                    "OUTPUT_FORMAT_LABEL": "Output format:",
                    "OUTPUT_FORMAT_ZIP": "ZIP (PDF + attachments)",
                    "OUTPUT_FORMAT_PDF": "PDF only",
                    "ESTIMATED_SIZE": "Estimated file size:",
                    "ZIP_NOTICE": "If Files is selected, the PDF and files will be downloaded as a ZIP.",
                    "CANCEL": "Cancel",
                    "EXPORT": "Export Report",
                    "EXPORTING": "Generating...",
                    "MIN_SELECTION": "Select at least one option.",
                    "DETAILS_TITLE": "Details",
                    "SESSIONS_TITLE": "Attached Sessions",
                    "FILES_TITLE": "Files",
                    "CHAT_TITLE": "Chat+Timeline",
                    "NO_ITEMS": "No data",
                    "FILE_TYPE": "Type",
                    "FILE_SIZE": "Size",
                    "FILE_UPLOADER": "Uploader",
                    "CHAT_TIME": "Time",
                    "CHAT_USER": "Sender",
                    "CHAT_MESSAGE": "Message",
                    "SESSION_HELD": "Remote session held",
                    "FILE_SHARED": "File shared: {{ file }}",
                    "FILE_SHARED_BY": "Shared a file: {{ file }}"
                }
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Video Flows",
                "CREATE-VIDEO-FLOW": "Create Video Flow",
                "CREATE-VIDEO-FLOW-PAGE": "Create Video Flow",
                "CREATED-BY-AI": "CreatedByAI",
                "VERSION": "Version",
                "NO-VIDEO-FLOWS-FOUND": "No video flows found",
                "CLEAR-ALL": "Clear all",
                "CONFIRM-VIDEO": "Confirm Video",
                "CONFIRM-VIDEO-TITLE": "Confirm Video Conversion",
                "CONFIRM-VIDEO-MESSAGE": "Are you sure you want to convert this video flow to a workflow? After confirmation, you will not be able to edit the video.",
                "CONFIRM-VIDEO-BUTTON": "Confirm & Convert",
                "MAKE-WORKFLOW-SUCCESSFUL": "Converted to workflow successfully",
                "MAKE-WORKFLOW-ERROR": "Failed to convert to workflow",
                "UPLOAD-VIDEO-DESCRIPTION": "Upload your video to automatically generate a step-by-step workflow guide.",
                "VIDEO-DURATION-LIMIT": "Video duration cannot exceed 30 minutes.",
                "VIDEO-UPLOADED-SUCCESS": "Video uploaded successfully!",
                "SELECT-VIDEO": "Select Video",
                "CHANGE-VIDEO": "Change Video",
                "CREATE-BUTTON": "Create",
                "AI-PROCESSING": "AI processing is underway",
                "SPLITTING-VIDEO": "Splitting video into segments",
                "TRANSCRIBING-VIDEO": "Transcribing video content",
                "PROCESS-WARNING": "This process may take up to 10 minutes. Please do not close this window."
            }
        },
        "NAVBAR": {
            "LOGOUT": {
                "TEXT": "Log out",
                "TEXT-MESSAGE": {
                    "MESSAGE": "Are you sure you want to logout?",
                    "CONFIRM": "Logout"
                }
            }
        },
        "CALL_MESSAGE": {
            "TITLE": "Incoming call from <strong>{{ caller_name }}</strong>",
            "DENY": "Deny",
            "ACCEPT": "Accept"
        },
        "SIDEBAR": {
            "WORK-ORDERS": "Work Orders",
            "TICKETS": "Tickets",
            "REMOTE-ASSISTANCE": "Remote Assistance",
            "WORKFLOWS": "Workflows",
            "VIDEO-FLOWS": "Video Flows",
            "USERS": "Users & Groups",
            "REPORTS": "Reports",
            "DRAFTS": "Reports",
            "ANALYTICS": "Analytics",
            "SETTINGS": "Settings",
            "SWITCH-ADMIN-PANEL": "Switch to Editor",
            "SWITCH-USER-PANEL": "Switch to User panel",
            "SWITCH-ADMIN-PANEL-TEXT": "To create and edit workflows, switch from User panel to Editor.",
            "SWITCH-USER-PANEL-TEXT": "To complete workflows, switch from Editor to User panel."
        },
        "USER-WORKFLOW": {
            "ADD": "ADD",
            "INVALID-EMAIL": "Invalid email",
            "SEND-REQUEST": "Send request to:",
            "SEND-REPORT": "Send report to:",
            "REMOVE": "REMOVE",
            "APPROVAL-REQUEST": "Approval Request",
            "REQUEST-SENDED-TEXT": "Your request for approval was successfully sent to the listed email addresses.",
            "CLOSE": "CLOSE",
            "LICENCE-LIMIT": "Your account has reached the maximum number of workflow submissions. Account administrator will see the report once the license is upgraded.",
            "REQUEST-PENDING": "Approval Request Pending",
            "REQUEST-APPROVAL": "Request Approval for Report",
            "REQUEST-REPORT": "Send Report After Approval",
            "SEND-REQUEST-TITLE": "SEND REQUEST",
            "SEND-REPORT-TITLE": "SEND REPORT",
            "TASK-TO-COMPLETE": "Task to complete:",
            "SELECT-LANGUAGE": "Select Language",
            "CONTENT-LANGUAGE": "Content Language:",
            "ESTIMATED-DURATION":"Estimated Duration:",
            "DELETE":"Delete",
            "DELETE-APPROVAL":"Are you sure you want to delete?",
            "EMAIL-INVALID": "Email format is invalid",
            "MISSING-EQUIPMENT": "Missing Equipment",
            "PROTECTED-EQUIPMENT": "Please use required personal protected equipments",
            "CONTINUE-WITH-QR-WARNING-TEXT": "You are about to hand over your workflow as prefilled. A link and QR code will be generated for the prefilled workflow to be accessed and continued later. Once the QR code is generated, the prefilled steps cannot be edited. Are you sure you want to proceed?",
            "CONTINUE-WITH-QR-TITLE": "HAND OVER PREFILLED WORKFLOW",
            "TABLE-OF-CONTENTS": "Table of Contents",
            "CALL-EXPERT": "Call Expert",
            "HAND-OVER": "Hand Over",
            "CANCEL": "CANCEL",
            "CALL": "CALL",
            "SAVE-CHANGES": "Save Changes",
            "CALL-PERMISSION-WARNING": "You don't have permission to call an expert. Please contact your system administrator.",
            "SELECT-EXPERT-TEXT": "Select the expert you want to call:",
            "ERRORS": {
                "INTEGRATION-NOT-FOUND": "Integration not found"
            },
            "QR-NOT-MATCHED": "QR code does not match",
            "STEP-FILES": {
                "TITLE": "STEP FILES"
            }
        },
        "LOBBY" : {
            "LOBBY_SHARED": {
                "ONGOING_CALLS_TITLE": "Ongoing Calls",
                "ROOMS_TITLE": "Your Work Groups",
                "UPCOMING_MEETINGS_TITLE" : "Upcoming Meetings",
                "PREVIOUS_MEETINGS_TITLE" : "Previous Meetings",
                "SCHEDULE_MEETING": "Schedule Meeting",
                "INSTANT_GUEST_ACCESS": "Instant Guest Access",
                "INSTANT_GUEST_ACCESS_NO_CALLING": "You don't have permission to make calls. Please contact your admin.",
                "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "You don't have permission to create a guest access link. Please contact your admin.",
                "INSTANT_GUEST_ACCESS_NO_PERM": "You don't have permission to make calls and create a guest access link. Please contact your admin.",
                "LINK_UNAVAILABLE": "Link unavailable",
                "JOIN" : "JOIN",
                "CANCEL": "CANCEL",
                "REMOVE": "REMOVE",
                "NO_ROOM": "You don't have any work groups.",
                "NO_MEETING": "You have no upcoming meetings.",
                "NO_PREV_MEETING": "You don't have any meeting.",
                "NO_OTHER_USERS": "No other users",
                "SHOW_MORE": "show {{ count }} more",
                "SHOW_LESS": "show less",
                "REMOTE_ASSISTANCE": "Remote Assistance",
                "NEW_REMOTE_SESSION": "New Remote Session",
                "START_INSTANT_CALL": "Start an Instant Call",
                "OVERVIEW": "Overview",
                "MEETINGS": "Meetings",
                "WORK_GROUPS": "Work Groups",
                "HISTORY": "History",
                "JOIN_REMOTE_SESSION": "Join a Remote Session",
                "JOIN_REMOTE_SESSION_DESCRIPTION": "Enter a shared link to join a scheduled meeting.",
                "ENTER_LINK_PLACEHOLDER": "Enter Link",
                "JOIN_BUTTON": "Join",
                "UPCOMING_SCHEDULED_MEETINGS": "Upcoming Scheduled Meetings",
                "VIEW_ALL_MEETINGS": "View all Meetings"
            },
            "SCHEDULE_MEETING_MODAL": {
                "TITLE": "Schedule Meeting",
                "MEETING_TITLE": "Title*",
                "MEETING_TITLE_REQUIRED": "Title required",
                "START_DATE": "Start",
                "END_DATE": "End",
                "CLOSE": "Close",
                "SCHEDULE_SEND": "Schedule & Send",
                "SCHEDULE": "Schedule",
                "CANNOT_SCHEDULE": "An error occurred while scheduling the meeting.",
                "CANNOT_CANCEL_MEETING": "An error occurred while canceling the meeting.",
                "ENTER_USERS": "Enter users",
                "SEND_INVITATIONS": "Send invitations",
                "INVITATION_EMAIL_LANG": "Invitation email language",
                "SHARE_AFTER": "The meeting link can also be shared after scheduling."
            },
            "CANCEL_MEETING_MODAL": {
                "CANCEL_TITLE": "Cancel Meeting",
                "REMOVE_TITLE": "Remove Meeting",
                "CANCEL_MESSAGE": "Are you sure you want to cancel the meeting?",
                "REMOVE_MESSAGE": "Are you sure you want to remove the meeting?",
                "CLOSE": "Close",
                "PROCEED": "Proceed"
            },
            "CONTACTS": {
                "TITLE": "User List",
                "NO_PERMISSION": "You don't have permission to view the user list and call other users.",
                "NO_CONTACT": "The list of all users is empty.",
                "SELECT_MULTI": "Select Multiple",
                "CALL": "Call",
                "ADMIN": "Admin",
                "COADMIN": "Co-Admin",
                "EXPERT": "Expert",
                "SUBSCRIBER": "Subscriber",
                "USER": "User",
                "NAME": "Name",
                "USERNAME": "Username",
                "ROLE": "Role",
                "NO_EXPERT": "Please select at least one expert to make a call.",
                "NAME_USERNAME": "Name or Username",
                "ALL_ROLES": "All Roles",
                "SEARCH_PLACEHOLDER": "Search name",
                "INSTANT_CALL_DESCRIPTION": "Make an instant call with a user or select multiple users to make a group call."
            },
            "SESSIONS": {
                "TITLE": "Sessions",
                "DATE": "Created On",
                "DURATION": "Duration",
                "ROOM_NAME": "Work Group",
                "NO_SESSIONS": "Session list is empty.",
                "PARTICIPANTS": "Participants",
                "EXPORT": "Export",
                "STATUS": "Status",
                "ON_GOING": "Ongoing",
                "ENDED": "Ended",
                "MORE": "more",
                "FILES": "Files",
                "CHAT": "Chat",
                "SESSION_FILES": {
                    "MULTIPLE_SELECTION": "Select Multiple",
                    "DOWNLOAD": "Download",
                    "DOWNLOAD_STARTED_SOON": "Download will be started soon.",
                    "DOWNLOAD_FAILED": "Download failed.",
                    "NO_FILE_IS_ADDED": "No file is added or collaborated in this session.",
                    "SUCCESS_MESSAGE": "The files have been successfully downloaded."
                },
                "ATTACHED_TICKET": "Attached Ticket",
                "SESSION_DETAILS": "Session Details",
                "BACK": "Back",
                "GET_SESSION_EXPORT": "Get Session Export",
                "ATTACH_TO_TICKET": "Attach to Ticket"
            },
            "ARCHIVES": {
                "ARCHIVE_LIST": {
                    "REFRESH": "Refresh",
                    "LOADING": "Loading video call records",
                    "NO_ARCHIVE_MESSAGE": "There is no video call record",
                    "NAME": "Name",
                    "CREATED_AT": "Created At",
                    "STORAGE": "Storage",
                    "DURATION": "Duration",
                    "ARCHIVES": "Video Call Records",
                    "SIZE": "File Size",
                    "STATUS": "Status",
                    "AVAILABLE": "available",
                    "DISCONNECTED": "disconnected",
                    "DELETED": "deleted",
                    "EXPIRED": "expired",
                    "WAITING": "waiting",
                    "FAILED": "failed",
                    "DOWNLOAD": "Download",
                    "PLAY": "Play",
                    "DELETE": "Delete",
                    "DOWNLOAD_ARCHIVE": {
                        "TITLE": "Download Record",
                        "GENERATING": "Generating Download URL",
                        "GENERATED": "Download URL Generated",
                        "CANNOT_GENERATED": "Cannot generate download URL.",
                        "DOWNLOAD": "Download",
                        "CLOSE": "Close"
                    },
                    "DELETE_ARCHIVE": {
                        "TITLE": "Delete Record",
                        "MESSAGE": "Video call record will be deleted.",
                        "CAUTION": "CAUTION: This record will be deleted from your Azure storage too.",
                        "CANCEL": "Cancel",
                        "DELETE": "Delete"
                    }
                }
            },
            "CONVERTER": {
                "TITLE": "Converter",
                "STP_ONLY": "Only .stp and .step file formats are supported.",
                "ERROR_UPLOAD": "An error occurred while uploading the file.",
                "DRAG": "Drag & Drop your file here",
                "OR": "or",
                "CHOOSE": "Choose File",
                "CONVERT": "Convert",
                "SUPPORTED": "Supported File Formats:",
                "BACK": "Back",
                "DOWNLOAD": "Download",
                "ERROR_LOAD": "An error occurred while loading the object."
            },
            "WHATSNEW": {
                "WHATSNEW_TITLE": "What's New",
                "NO_UNREAD_UPDATE": "No unread update"
            },
            "JOIN_MODAL": {
                "JOIN" : "JOIN",
                "CALL": "CALL",
                "CANCEL": "CANCEL",
                "MIRROR_VIDEO": "Mirror Video",
                "PREFERRED_RESOLUTION": "Preferred Resolution",
                "RESOLUTION_NOTE": "Note: If your device cannot support the resolution you requested, the next largest resolution will be used.",
                "CAM_MIC_PERM_REQUIRED": "Camera and microphone permission required",
                "CAM_MIC_PERM_DENIED": "Camera or microphone access denied",
                "CAM_MIC_CANT_ACCESS": "We can't access your camera or microphone",
                "JOIN_CAM_OFF": "Join with camera switched off",
                "JOIN_MIC_OFF": "Join with microphone switched off",
                "JOIN_CAM_MIC_OFF": "Join with camera and microphone switched off",
                "JOIN_NO_DEVICE": "Join with no camera and microphone",
                "ALLOW_ACCESS": "You need to allow access to your camera and microphone in your browser settings (After you grant access, you can still turn off your camera or microphone).",
                "TRY_AGAIN": "Try again/refresh the page and select 'Allow' when prompted by your browser."
            },
            "NO_DEVICE_MODAL": {
                "TITLE": "No Device Found",
                "JOIN_BODY": "There is no microphone and camera connected to this device. Other users will not be able to hear or see you through this device. Do you still want to join?",
                "CALL_BODY": "There is no microphone and camera connected to this device. Other users will not be able to hear or see you through this device. Do you still want to call?",
                "CANCEL": "Cancel",
                "JOIN": "Join Anyway",
                "CALL": "Call Anyway"
            },
            "AGREEMENT_MODAL": {
                "TITLE": "Processing and Security of Personal Data Approval Form",
                "REJECTION_BUTTON": "Reject",
                "AGREEMENT_BUTTON": "Agree"
            },
            "CHECK_AGREEMENT_MODAL": {
                "TITLE": "Cancel the contract?",
                "ERROR": "An error has occurred.",
                "STATEMENT": "When you do not accept the contract, you will not be able to login to the system.",
                "CANCEL_BUTTON": "Cancel",
                "PROCEED_BUTTON": "Proceed"
            },
            "JOIN_UNKNOWN_ERROR" : "An error has occurred when joining the session in work group.",
            "JOIN_CONCURRENT_ERROR" : "You have reached your account concurrent user limit. Please contact your admin for more details.",
            "JOIN_EXPERT_CONCURRENT_ERROR": "You have reached your expert concurrent user limit. Please contact your admin for more details.",
            "NO_TRAINING_LICENSE": "There is a problem with your academy work group licence. Please contact your admin.",
            "TRAINING_LICENSE_EXPIRED": "Your academy work group licence has been expired. Please contact your admin.",
            "ASK_TRAINING_HOST": "An error has occurred when joining the session in academy work group. Please contact the host.",
            "JOIN_CALL_IN_PROGRESS": "There is an another call in your personal meeting work group.",
            "NOT_SUPPORTED_TITLE": "Incompatible Browser",
            "NOT_SUPPORTED_MESSAGE": "Your browser is not compatible. Please use Google Chrome, Mozilla Firefox, Safari or Microsoft Edge (version 79 or newer).",
            "NO_IOS_MESSAGE": "Your browser is not compatible. Please use {{ appName }} Remote application or use Safari.",
            "IOS_VERSION_MESSAGE": "Your browser is not compatible. Please use {{ appName }} Remote application.",
            "NOT_SUPPORTED_CLOSE": "Close",
            "IDLE_MODAL_TITLE": "Error",
            "IDLE_MODAL_MESSAGE": "You did not do any transaction for a longer period.",
            "IDLE_MODAL_COUNT": "You will be logged out in {{ count }} seconds.",
            "IDLE_MODAL_OK": "I'm Back",
            "ARCHIVE_PERMISSION_MODAL": {
                "TITLE": "Allow Recording?",
                "MESSAGE": "The meeting in this work group will be recorded. You need to allow video recording, in order to join session in this work group.",
                "DENY": "Deny",
                "ALLOW": "Allow"
            }
        },
        "ARCHIVES": {
            "ARCHIVE_LIST": {
                "REFRESH": "Refresh",
                "LOADING": "Loading video call records",
                "NO_ARCHIVE_MESSAGE": "There is no video call record",
                "NAME": "Name",
                "CREATED_AT": "Created At",
                "STORAGE": "Storage",
                "DURATION": "Duration",
                "ARCHIVES": "Video Call Records",
                "SIZE": "File Size",
                "STATUS": "Status",
                "AVAILABLE": "available",
                "DISCONNECTED": "disconnected",
                "DELETED": "deleted",
                "EXPIRED": "expired",
                "WAITING": "waiting",
                "FAILED": "failed",
                "DOWNLOAD": "Download",
                "PLAY": "Play",
                "TRANSCRIBE": "Transcribe",
                "TRANSCRIBING": "Transcribing",
                "VIEW_TRANSCRIPT": "Transcript",
                "RETRY_TRANSCRIPTION": "Retry transcription",
                "TRANSCRIPTION": "Transcription",
                "TRANSCRIPTION_FAILED": "Transcription failed",
                "NO_TRANSCRIPT": "No speech was detected in this recording.",
                "NO_TRANSCRIPT_HINT": "The recording finished successfully, but there is no spoken content to show here.",
                "LANGUAGE": "Language",
                "FULL_TEXT": "Full text",
                "SPEAKERS": "speakers",
                "SEGMENTS": "segments",
                "DELETE": "Delete",
                "GENERATING": "Generating...",
                "PLEASE_WAIT": "Please wait...",
                "WEBDAV": "WEBDAV",
                "DOWNLOAD_ARCHIVE": {
                    "TITLE": "Download Record",
                    "GENERATING": "Generating Download URL",
                    "GENERATED": "Download URL Generated",
                    "CANNOT_GENERATED": "Cannot generate download URL.",
                    "DOWNLOAD": "Download",
                    "CLOSE": "Close"
                },
                "DELETE_ARCHIVE": {
                    "TITLE": "Delete Record",
                    "MESSAGE": "Video call record will be deleted.",
                    "CAUTION": "CAUTION: This record will be deleted from your Azure storage too.",
                    "CANCEL": "Cancel",
                    "DELETE": "Delete"
                }
            }
        },
        "ROOMS": {
            "ROOM_DETAILS": {
                "BACK": "Back",
                "TITLE_NEW": "New Work Group",
                "TITLE_DETAILS": "Work Group Details",
                "TITLE_EDIT": "Edit Work Group",
                "ROOM_DISABLED": "WORK GROUP DISABLED",
                "EDIT": "Edit",
                "RESET": "Reset",
                "REVERT": "Revert",
                "CANCEL": "Cancel",
                "ICON": "Icon",
                "CHOOSE_FILE": "Choose file...",
                "ROOM_NAME": "Work Group Name",
                "TECHNICAL_DRAWING": "Technical Drawing",
                "HAND_TOOLS": "Hand Tools",
                "FINISHED_PRODUCT": "Finished Product",
                "VIDEO": "Video",
                "ROOM_NAME_REQUIRED": "Work group name required",
                "ROOM_NAME_LENGTH": "Work group name length must be between 1-60",
                "DESCRIPTION": "Description",
                "DESCRIPTION_REQUIRED": "Description required",
                "DESCRIPTION_LENGTH": "Description length must be between 1-100",
                "USERS": "Users",
                "SELECT_USERS": "Select User",
                "SAVE": "SAVE",
                "ROOM_UPDATED": "Work group updated successfully.",
                "CANNOT_UPDATE": "Cannot update work group.",
                "ROOM_CREATED": "Work group created.",
                "CANNOT_CREATE": "Cannot create work group.",
                "CREATE_WORK_GROUP": "Create Work Group",
                "EDIT_WORK_GROUP_DETAILS": "Edit Work Group Details",
                "ENABLE_WORK_GROUP": "Enable Work Group",
                "DISABLE_WORK_GROUP": "Disable Work Group",
                "DELETE_WORK_GROUP": "Delete Work Group",
                "UPLOAD_IMAGE": "Upload Image",
                "ALWAYS_ARCHIVE_ON": "All sessions in work groups are recording in your account. You can change this in the settings.",
                "ARCHIVE_UNAVAILABLE": "Your Licence doesn't have video call record feature.",
                "PEER_TO_PEER_NO_ARCHIVE": "Recording is not available for Peer-to-Peer work groups.",
                "AUTO_ARCHIVE": "Automatically record video calls in this work groups",
                "ARCHIVE_PERMISSION_NEEDED": "Require all users' permission to start recording.",
                "PEER_TO_PEER": "Make video calls Peer-to-Peer",
                "WHAT_IS_PEER_TO_PEER": "(What is P2P)",
                "PEER_TO_PEER_UNAVAILABLE": "Your Licence doesn't have Peer-to-Peer feature.",
                "FULL_HD": "Make stream/snapshot quality FullHD on supported mobile devices",
                "FULL_HD_DISADVANTAGES": "Please use this option when the participants' internet connection is stable. Also note that this might consume more energy and data on mobile devices and create connectivity issues.",
                "ALWAYS_FULL_HD_ON": "Streaming/snapshot quality for mobile devices for all work groups is FullHd. You can change this in the settings.",
                "FULL_HD_UNAVAILABLE": "Your Licence doesn't have FullHD feature.",
                "TRAINING_ROOM_NO_PEER_TO_PEER": "Peer-to-Peer unavailable for academy work groups.",
                "TRAINING_ROOM": "Academy Work Group",
                "TRAINING_LICENSE": "Academy Work Group Licence",
                "TRAINING_LICENSE_REQUIRED": "Academy work group licence required.",
                "TRAINING_MASTER": "Host of Academy Work Group",
                "TRAINING_MASTER_REQUIRED": "Host required for academy work groups.",
                "TRAINING_ROOM_UNAVAILABLE": "Your Licence doesn't have academy work group feature.",
                "WHAT_IS_P2P": {
                    "TITLE": "What is Peer-to-Peer",
                    "BETWEEN_CLIENTS": "Clients send audio-video streams directly between each other.",
                    "REDUCED_LATENCY": "Peer-to-Peer option offers the benefit of reduced latency.",
                    "ARCHIVE_UNAVAILABLE": "Peer-to-Peer session cannot be recorded because connection is directly established between the peers involved in the session.",
                    "CLOSE": "Close"
                },
                "ENABLE_ROOM": "ENABLE WORK GROUP",
                "DISABLE_ROOM": "DISABLE WORK GROUP",
                "TOGGLE_ROOM_MODAL": {
                    "TITLE_ENABLE": "Enable Work Group?",
                    "TITLE_DISABLE": "Disable Work Group?",
                    "MESSAGE_ENABLE": "Are you sure you want to enable work group <strong>{{name}}</strong>",
                    "MESSAGE_DISABLE": "Are you sure you want to disable work group <strong>{{name}}</strong>",
                    "CANCEL": "Cancel",
                    "ENABLE": "Enable",
                    "DISABLE": "Disable",
                    "ENABLED": "Work group enabled.",
                    "DISABLED": "Work group disabled.",
                    "ERROR": "Work group status cannot be changed."
                },
                "DELETE_ROOM": "DELETE WORK GROUP",
                "DELETE_ROOM_MODAL": {
                    "TITLE": "Delete Work Group?",
                    "MESSAGE": "Are you sure you want to delete work group <strong>{{name}}</strong>",
                    "CANCEL": "Cancel",
                    "DELETE": "Delete",
                    "DELETED": "Work group deleted.",
                    "ERROR": "Work group cannot be deleted."
                },
                "CHANGE_AUTO_ARCHIVE_MODAL": {
                    "TITLE": "Save Work Group Changes",
                    "MESSAGE_START": "Changes on ",
                    "AUTO_ARCHIVE": "automatic video call record",
                    "AND": " and ",
                    "PEER_TO_PEER": "Peer-to-Peer",
                    "MESSAGE_END": " will be applied to subsequent sessions.",
                    "CAUTION": "CAUTION: Record is unavailable when Peer-to-Peer is enabled.",
                    "TRAINING_CAUTION": "While this work group is turned into a academy work group (or vice versa), everyone in this work group will be kicked out.",
                    "CANCEL": "Cancel",
                    "SAVE": "Save"
                }
            },
            "ROOM_LIST": {
                "TITLE": "Work Groups",
                "NO_ROOM_MESSAGE": "Work group list is empty",
                "NEW_ROOM": "New Work Group",
                "ICON": "Icon",
                "ROOM_NAME": "Work Group Name",
                "DISABLED": "disabled",
                "USERS": "Users",
                "ACTIVE": "Active",
                "PASSIVE": "Passive",
                "DETAILS": "Details",
                "EDIT": "Edit",
                "DELETE": "Delete",
                "DISABLE": "Disable",
                "ENABLE": "Enable",
                "ROOM_LIMIT_REACHED": "Maximum work group limit reached.",
                "GUEST": "Guest",
                "ALL_USERS": "All Users"
            }
        },
        "SESSIONS": {
            "SESSION_DETAILS": {
                "TITLE": "Session Details",
                "BACK": "Back",
                "WIPE_SESSION_DATA": "Delete Session Data",
                "SESSION_DATA_WIPED": "Session data already deleted",
                "PARTICIPANTS": "Participants",
                "CREATED_AT": "Created At: ",
                "DURATION": "Duration",
                "GUEST": "(Guest)",
                "ATTACHED_TICKET": "Attached Ticket",
                "ATTACH_TO_TICKET": "Attach to Ticket",
                "CHANGE_TICKET": "Change Ticket",
                "ATTACH_SESSION_TO_TICKET": "Attach Session to Ticket",
                "CLOSE": "Close",
                "ATTACH": "Attach",
                "APPLY_FILTERS": "Apply Filters",
                "SESSIONS": "Sessions",
                "SESSION_COUNT": "Session Count",
                "TOTAL_DURATION": "Total Duration",
                "EXPORT": "Export",
                "GET_SESSION_EXPORT": "Get Session Export",
                "DATE": "Date",
                "USER_ROLES": {
                    "UNKNOWN": "Unknown",
                    "ADMIN": "Admin",
                    "CO_ADMIN": "Co-Admin",
                    "EXPERT": "Expert",
                    "USER": "User",
                    "SUBSCRIBER": "Subscriber"
                },
                "SESSION_EXPORT": {
                    "TITLE": "Session Export",
                    "MESSAGE": "Session export will include all chat messages, snapshots, video call records and files shared in the session.",
                    "SEND": "SEND",
                    "EXPORT_SUCCEEDED": "Session export will be sent after the session ends.",
                    "EXPORT_FAILED": "An error occurred.",
                    "WARNING": "Please press Enter after each email address."
                },
                "WIPE_SESSION_DATA_MODAL": {
                    "TITLE": "Delete Session Data?",
                    "MESSAGE": "Are you sure you want to delete session data? Snapshots, video call records and files shared in the session will be deleted.",
                    "WARNING": "This operation cannot be undone.",
                    "CLOSE": "Close",
                    "WIPE": "Delete",
                    "WIPE_SUCCEEDED": "Session data deleted.",
                    "WIPE_FAILED": "An error occurred."
                },
                "SESSION_CHAT" : {
                    "COLLABORATE": "Collaborate",
                    "CLOSE_COLLABORATION": "Close Collaboration",
                    "DOWNLOAD": "Download",
                    "DELETE": "Delete",
                    "DETAILS": "Details",
                    "FILE_DELETED": "File deleted",
                    "JOIN_ROOM" : "{{ owner_info }} joined work group.",
                    "LEAVE_ROOM" : "{{ owner_info }} left work group.",
                    "REACTION": "{{ owner_info }} sended a reaction",
                    "REQUEST_SCREENSHOT": "{{ owner_info }} requested snapshot.",
                    "SHARE_SCREENSHOT" : "{{ owner_info }} shared a snapshot.",
                    "SHARE_IMAGE" : "{{ owner_info }} shared an image.",
                    "SHARE_PDF" : "{{ owner_info }} shared a pdf.",
                    "SHARE_OTHER" : "{{ owner_info }} shared a file.",
                    "SHARE_OBJECT" : "{{ owner_info }} shared a 3D object.",
                    "COLLABORATED" : "{{ owner_info }} started collaboration."
                },
                "FILES": "Files",
                "CHAT": "Chat"
            },
            "SESSION_LIST": {
                "ALL_SESSIONS": "Sessions",
                "LAST_SESSIONS": "Last Sessions",
                "ROOM_SESSIONS": "Last 3 Sessions in {{room}}",
                "LOADING": "Loading",
                "NO_SESSION_MESSAGE": "Session list is empty",
                "DATE": "Date",
                "ROOM_NAME": "Work Group Name",
                "PARTICIPANTS": "Participants",
                "STATUS": "Status",
                "DURATION": "Duration",
                "GUEST": "(Guest)",
                "ON_GOING": "Ongoing",
                "ENDED": "Ended",
                "START_END": "Start End",
                "ALL_ROOMS": "All Work Groups",
                "ALL_USERS": "All Users",
                "ALL_LABELS": "All Labels",
                "CSV": "CSV",
                "EXPORT_HEADER": "Created At,Room,Duration (min),Participants",
                "UNKNOWN": "Unknown",
                "GUEST_LABEL": " (Guest)",
                "MORE": "more"
            },
            "SESSION_FILES": {
                "DOWNLOAD_STARTED_SOON": "Download will be started soon.",
                "DOWNLOAD_FAILED": "Download failed.",
                "NO_FILE_IS_ADDED": "No file is added or collaborated in this session.",
                "FILE_NAME": "File Name:",
                "FILE_CONTENTS": "File Contents:",
                "FILE_SIZE": "File Size:",
                "ESTIMATED_FILE_SIZE": "Estimated Size:",
                "APPROX_EXPORT_PDF_SIZE": "Approx. 60 KB"
            }
        },
        "USERS": {
            "USER_DETAILS": {
                "BACK": "Back",
                "TITLE_NEW": "New User",
                "TITLE_DETAILS": "User Details",
                "TITLE_EDIT": "Edit User",
                "USER_DISABLED": "USER DISABLED",
                "EDIT": "Edit",
                "RESET": "Reset",
                "REVERT": "Revert",
                "CANCEL": "Cancel",
                "USER_ROLE": "Role",
                "ADMIN": "Admin",
                "COADMIN": "Co-Admin",
                "USER": "User",
                "SUBSCRIBER": "Subscriber",
                "EXPERT": "Expert",
                "NAME": "Name",
                "ROLE": "Role",
                "PERMISSIONS": "Permissions",
                "CLOSE": "Close",
                "REACHED_MAX_NUMBER_EXPERT_LIMIT": "You have reached the maximum number of expert limit.",
                "SINGLE_SIGN_ON_CODE": "Single Sign-On Code",
                "GENERATING": "Generating",
                "GENERATE_CODE": "Generate Code",
                "CLICK_CODE_FOR_COPY": "Click on the code to copy it",
                "ARCHIVE_UNAVAILABLE": "Your Licence doest'n have video call record feature.",
                "ALLOW_ARCHIVING": "Permission of start/stop recording video calls",
                "PERSONAL_ROOM_SETTINGS": "Personal Work Group Settings (During Call)",
                "CALL_ARCHIVE_PERM_NEEDED": "Require all users' permission to start recording.",
                "CALLING_UNAVAILABLE": "Your Licence doest'n have calling feature.",
                "ALLOW_CALLING": "Permission to make calls",
                "ALLOW_SEEING_ALL_USERS": "Permission to see the user list",
                "JOIN_LINK_UNAVAILABLE": "Your Licence doesn't have guest access feature.",
                "ALLOW_JOIN_LINK": "Permission to create \"Guest Access\"",
                "PERMISSION_TO_SEE_USERS_IN_SAME_ROOM": "Permission to see users in the same work group",
                "PERMISSION_TO_SEE_USERS_ALL": "Permission to see all users",
                "NAME_REQUIRED": "Name required",
                "NAME_START_WITH": "Starts with alphanumeric.",
                "NAME_CONTAINS": "Can contain alphanumerical and special characters -._ (space)",
                "NAME_LENGTH": "Name length must be between 1-60",
                "USERNAME": "Username",
                "USERNAME_REQUIRED": "Username required",
                "USERNAME_ALREADY_TAKEN": "Already taken",
                "USERNAME_CONTAINS": "Choose a username that contains only alphanumerical characters, underscore ( _ ) and hyphen ( - )",
                "USERNAME_LENGTH": "Username length must be between 1-30",
                "EMAIL": "Email",
                "EMAIL_REQUIRED": "Email required when two factor authentication is enabled.",
                "EMAIL_INVALID": "Invalid email",
                "PASSWORD": "Password",
                "PASSWORD_REQUIRED": "Password required",
                "PASSWORD_MINLENGTH": "Password length must be between 6-30",
                "CONFIRM_PASSWORD": "Confirm Password",
                "CONFIRM_PASSWORD_NOTMATCH": "Passwords do not match.",
                "DEFAULT_ROOM": "Default Work Group",
                "ROOMS": "Work Groups",
                "WORK_GROUP_SETTINGS": "Work Group Settings",
                "SELECT_ROOMS": "Select Work Groups",
                "SAVE": "SAVE",
                "CALL_INFO_MODAL": {
                    "TITLE": "Calling Permission?",
                    "MESSAGE": "Users with calling permission can access the user list and make calls without the need to previously created a work group.",
                    "CLOSE": "Close"
                },
                "QR_CODE_TITLE": "QR Code",
                "QR_CODE_LOADING": "QR Code Is Loading",
                "QR_ENABLE_FIRST": "User Disabled",
                "NO_QR_CODE": "No QR Code",
                "GENERATE_QR": "Generate QR Code",
                "QR_MESSAGE": "You can authenticate smart glasses and mobile phones with this QR code.",
                "REGENERATE": "Regenerate",
                "REMOVE": "Delete",
                "DOWNLOAD": "Download",
                "CHANGE_PASSWORD_TITLE": "Change Password",
                "CHANGE_PASSWORD": "CHANGE PASSWORD",
                "CREATE_NEW_PASSWORD": "Password Requirements",
                "UPPERCASE": "Uppercase",
                "LOWERCASE": "Lowercase",
                "NUMBER": "Number",
                "SPECIAL": "Special",
                "NOT_WHITESPACE": "Your password must not contain space characters",
                "AT_LEAST_PASSWORD_LENGTH": "At least {{ passwordlength }} characters",
                "DO_NOT_CREATE_SIMPLE": "Do not create weak passwords like '123456'",
                "CHANGE_PASSWORD_MODAL": {
                    "TITLE": "Change password?",
                    "MESSAGE": "User password will be changed.",
                    "CAUTION": "CAUTION: Please note that the current user QR code will be deleted.",
                    "CANCEL": "Cancel",
                    "CHANGE": "Change"
                },
                "PASSWORD_CHANGED": "Password changed.",
                "CANNOT_CHANGE": "Cannot change password.",
                "QR_REMOVE_TITLE": "Delete QR Code?",
                "QR_REMOVE_MESSAGE": "QR code will be deleted.",
                "QR_REMOVE_NO": "Cancel",
                "QR_REMOVE_YES": "Delete",
                "QR_REGENERATE_TITLE": "Regenerate?",
                "QR_REGENERATE_MESSAGE": "Previous QR code will be disabled.",
                "QR_REGENERATE_NO": "Cancel",
                "QR_REGENERATE_YES": "Regenerate",
                "QR_REMOVED": "QR code deleted.",
                "CANNOT_REMOVE": "Cannot delete QR code.",
                "QR_GENERATED": "QR code generated.",
                "CANNOT_GENERATE": "Cannot generate QR code.",
                "USER_UPDATED": "User updated successfully.",
                "CANNOT_UPDATE": "Cannot update user.",
                "USER_CREATED": "User created.",
                "CANNOT_CREATE": "Cannot create user.",
                "UPDATE_USER_MODAL": {
                    "TITLE": "Apply Changes?",
                    "USENAME_MESSAGE": "Username will be changed.",
                    "USENAME_CAUTION": "CAUTION: Please note that the current user QR code will be deleted.",
                    "EMAIL_MESSAGE": "Admin email will be deleted.",
                    "EMAIL_CAUTION": "CAUTION: You will no longer receive weekly usage reports. Other recipients will also be removed.",
                    "CANCEL": "Cancel",
                    "CHANGE": "Change"
                },
                "WITHOUT_ROOM_MODAL": {
                    "TITLE": "Create user without any work group?",
                    "MESSAGE": "User will be created without any work group.",
                    "CANCEL": "Cancel",
                    "CREATE": "Create"
                },
                "DISABLE_USER": "DISABLE USER",
                "ENABLE_USER": "ENABLE USER",
                "TOGGLE_USER_MODAL": {
                    "TITLE_ENABLE": "Enable User?",
                    "TITLE_DISABLE": "Disable User?",
                    "MESSAGE_ENABLE": "Are you sure you want to enable user <strong>{{name}}</strong>",
                    "MESSAGE_DISABLE": "Are you sure you want to disable user <strong>{{name}}</strong>",
                    "CANCEL": "Cancel",
                    "ENABLE": "Enable",
                    "DISABLE": "Disable",
                    "ENABLED": "User enabled.",
                    "DISABLED": "User disabled.",
                    "ERROR": "User status cannot be changed."
                },
                "DELETE_USER": "DELETE USER",
                "DELETE_USER_MODAL": {
                    "TITLE": "Delete User?",
                    "MESSAGE": "Are you sure you want to delete user <strong>{{name}}</strong>",
                    "CAUTION": "CAUTION: This cannot be undone!",
                    "CANCEL": "Cancel",
                    "DELETE": "Delete",
                    "DELETED": "User deleted.",
                    "ERROR": "User cannot be deleted."
                },
                "LABEL": "Label",
                "CREATE_NEW_LABELS": "Create new"
            },
            "ALL_ROOMS": "All Rooms",
            "ALL_ROLES": "All Roles",
            "NAME_USERNAME": "Name or Username"
        },
        "ANALYTICS": {
            "TITLE": "Organization Analytics",
            "DASHBOARD": "Dashboard",
            "USAGE": "Usage",
            "TOTAL_COMPLETIONS": "Total Submissions",
            "ACTIVE_DOMAINS": "Active Domains",
            "SHARED_WORKFLOWS": "Shared Workflows",
            "COMPLETIONS_BY_DOMAIN": "By Domain",
            "COMPLETIONS_BY_WORKFLOW": "By Workflow",
            "NOT_AVAILABLE": "Analytics is only available for parent accounts.",
            "START_DATE": "Start Date",
            "END_DATE": "End Date",
            "DOMAIN": "By Domain",
            "WORKFLOW": "By Workflow",
            "COMPLETIONS": "Completions",
            "TOTAL_WORKFLOWS": "Total Workflows",
            "TOTAL_SHARED_WORKFLOWS": "Total Shared Workflows",
            "TOTAL_USERS": "Total Users",
            "TOTAL_SUBMISSIONS": "Total Submissions",
            "CHILD_ACCOUNTS_BREAKDOWN": "Child Accounts Breakdown",
            "ACCOUNT": "Account",
            "WORKFLOWS": "Workflows",
            "SHARED": "Shared",
            "USERS": "Users",
            "SUBMISSIONS": "Submissions"
        },
        "SETTINGS": {
            "TABS": {
                "GENERAL": "General",
                "INTEGRATIONS": "Integrations",
                "LICENSE": "License",
                "TICKET": "Ticket"
            },
            "ARCHIVE": {
                "TITLE": "Video Call Record Settings",
                "ROOMS": "Work Groups",
                "RECORD_STATUS": "Record Status",
                "AUTO": "Auto",
                "P2P": "P2P",
                "MANUAL": "Manual",
                "AUTO_RECORD": "Automatically Record All Work Groups",
                "CHANGE_INDIVIDUALLY": "You can change work group record behavior at individual work group pages.",
                "NO_ARCHIVE": "Your Licence does not have video call record feature.",
                "SAVE": "SAVE"
            },
            "ALWAYS_FULL_HD": {
                "TITLE": "Stream/Snapshot Quality for Mobile Devices (Including Meetings & Calls)",
                "FULL_HD_MESSAGE": "Make stream/snapshot quality FullHD on supported mobile devices",
                "INDIVIDUAL_MESSAGE": "You can change stream/snapshot quality behavior on work group and user (for calls) pages individually",
                "CANCEL": "Cancel",
                "PROCEED": "Proceed",
                "CHANGE": "Change Individually",
                "SAVE": "SAVE"
            },
            "FULL_HD_MODAL": {
                "FULL_HD": "Make Stream/Snapshot Quality FullHD",
                "CHANGE_INDIVIDUALLY": "Change Stream/Snapshot Quality Behavior Individually",
                "FULL_HD_MESSAGE": "Stream/snapshot quality will be FullHD on supported mobile devices.",
                "INDIVIDUAL_MESSAGE": "You can change stream/snapshot quality behavior on work group and user (for calls) pages individually.",
                "WARNING": "Stream/snapshot quality changes will be applied to subsequent sessions.",
                "CANCEL": "Cancel",
                "PROCEED": "Proceed",
                "CHANGE": "Change Individually"
            },
            "EMAIL_RECIPIENTS": {
                "TITLE": "Weekly Usage Report Recipient List",
                "MESSAGE": "You can add more e-mail addresses to receive weekly usage report from {{ appName }}",
                "PLACEHOLDER": "Add new",
                "SECONDARY_PLACEHOLDER": "Enter email address",
                "ADMIN_MAIL_FIRST": "Please first add the admin email address from the users menu",
                "INVALID_EMAIL": "Invalid email format.",
                "SAVE": "SAVE",
                "CANNOT_CHANGE": "The recipient list cannot be updated.",
                "WARNING": "Please press Enter after each email address."
            },
            "TWO_FACTOR_AUTH": {
                "TITLE": "Two Factor Authentication",
                "ADMIN_2FA": "Admin Panel Two Factor Authentication",
                "EXPERT_2FA": "Expert Two Factor Authentication",
                "CAUTION": "You must enable admin two factor before enabling for experts.",
                "ENABLE": "Enable",
                "DISABLE": "Disable",
                "TWO_FACTOR_UNAVAILABLE": "Your licence doesn't contain the Two Factor Authentication feature.",
                "TWO_FACTOR_ENABLED": "Two factor authentication enabled",
                "TWO_FACTOR_DISABLED": "Two factor authentication disabled"
            },
            "TIMEZONE": {
                "TITLE": "Change Timezone",
                "SAVE": "SAVE",
                "CANNOT_CHANGE": "The timezone cannot be updated."
            },
            "DEFAULT_WORK_GROUPS": {
                "TITLE": "Default Work Groups",
                "MESSAGE": "Select the work groups that new users are assigned to by default.",
                "SELECT": "Select work groups",
                "NO_WORK_GROUP": "There is no work group in this account yet.",
                "SAVE": "SAVE",
                "SAVED": "Default work groups are updated.",
                "CANNOT_CHANGE": "The default work groups cannot be updated.",
                "STALE_SELECTION": "One of the selected work groups no longer exists. Reload the page and try again."
            },
            "VOICE_COMMANDS": {
                "TITLE": "Voice Commands",
                "NEW_COMMAND": "New Command",
                "LOADING": "Loading",
                "NO_COMMAND": "Command list is empty",
                "COMMAND": "Command",
                "TRANSLATION": "Translation",
                "LANGUAGE": "Language",
                "UNAVAILABLE": "Your licence does not contain the Voice Commands feature.",
                "ADD_MODAL": {
                    "TITLE": "Add New Command",
                    "CLOSE": "Close",
                    "ADD": "Add"
                }
            },
            "AZURE_AD": {
                "CANCEL": "Cancel",
                "ADD": "Add",
                "REMOVE": "Remove",
                "COPY": "Copy",
                "AZURE_AD_INTEGRATION": "Azure AD Integration",
                "SINGLE_SIGN_ON": "Single Sign-On",
                "CONFIGURE_SAML": "You can configure SAML-based single sign-on from here.",
                "ADD_SAML_CONFIGURATION": "Add SAML Configuration",
                "REMOVE_SAML_CONFIGURATION": "Remove SAML Configuration",
                "INFORMATION": "Information required by Azure Active Directory",
                "INFORMATION_VSIGHT": "Information required by VSight",
                "IDENTIFIER": "Identifier (Entity ID)",
                "REPLY_URL": "Reply URL",
                "REPLY_URL2": "Reply URL2",
                "REPLY_URL3": "Reply URL3",
                "USER_PROVISIONING": "User Provisioning",
                "SCIM_USER_PROVISIONING": "You can configure SCIM-based user provisioning from here.",
                "ADD_SCIM_CONFIGURATION": "Add SCIM Configuration",
                "REMOVE_SCIM_CONFIGURATION": "Remove SCIM Configuration",
                "INFO": "Information required by Azure Active Directory",
                "ENDPOINT": "SCIM Endpoint (Tenant URL)",
                "ADD_SAML": "Add SAML Configuration",
                "SSO": "Identity Provider SSO URL",
                "SSO_URL_REQUIRED": "SSO URL required.",
                "CERTIFICATE": "Public x509 Certificate",
                "CERTIFICATE_REQUIED": "Certificate required.",
                "GENERATE_TOKEN_FOR_SCIM": "Generate Token for SCIM",
                "REMOVE_SAML_CONFIGURATION_QUESTION": "Are you sure you want to remove the SAML configuration?",
                "REMOVE_SCIM_CONFIGURATION_QUESTION": "Are you sure you want to remove the SCIM configuration?"
            },
            "OAUTH_OIDC": {
                "OAUTH_OIDC_TITLE": "OAUTH OIDC CONFIGURATION",
                "OAUTH_OIDC": "OAUTH OpenID Connect",
                "CONFIGURE_OAUTH_OIDC": "You can configure OAUTH OpenID Connect from here.",
                "ADD_OAUTH_OIDC_CONFIGURATION": "Add OIDC Configuration",
                "REMOVE_OAUTH_OIDC_CONFIGURATION": "Remove OIDC Configuration",
                "INFORMATION": "Details",
                "INITIATE_LOGIN_URL": "Initiate Login Url",
                "REDIRECT_URL": "Redirect Url",
                "COPY": "Copy",
                "ADD_OIDC": "Add OIDC Configuration",
                "INFORMATION_VSIGHT": "Information required by VSight",
                "DISCOVERY_ENDPOINT": "Discovery Endpoint (OpenID Connect metadata document)",
                "DISCOVERY_ENDPOINT_REQUIRED": "Discovery endpoint required.",
                "CLIENT_ID": "Client ID",
                "CLIENT_ID_REQUIRED": "Client ID required.",
                "CLIENT_SECRET": "Client Secret",
                "CLIENT_SECRET_REQUIRED": "Client secret required.",
                "RESPONSE_TYPE": "Response Type",
                "RESPONSE_TYPE_CODE": "code",
                "LOGOUT_URL": "Logout Url",
                "REMOVE_OIDC_CONFIGURATION": "Remove OIDC Configuration",
                "REMOVE_OIDC_CONFIGURATION_QUESTION": "Are you sure you want to remove the OIDC configuration?",
                "CANCEL": "Cancel",
                "ADD": "Add",
                "REMOVE": "Remove"
            },
            "ENABLE_SYSTEM_EMAIL": {
                "CONFIGURE_CUSTOM_SERVICE_EMAIL": "Configure Custom Service Email",
                "SENDER_NAME": "Sender Name",
                "SENDER_NAME_IS_REQUIRED": "Sender name required.",
                "SENDER_HOST": "Sender Host",
                "SENDER_HOST_IS_REQUIRED": "Sender host required.",
                "SENDER_PORT": "Sender Port",
                "SENDER_EMAIL": "Sender Email",
                "SENDER_EMAIL_IS_REQUIRED": "Sender email required.",
                "USER": "User",
                "USER_IS_REQUIRED": "User required.",
                "EMAIL_FORMAT_IS_INVALID": "Invalid email format.",
                "PASSWORD": "Password",
                "PASSWORD_IS_REQUIRED": "Password required.",
                "CANCEL": "Cancel",
                "VERIFY": "Verify",
                "VERIFY_CUSTOM_SERVICE_EMAIL": "Verify Custom Service Email",
                "SEND_VERIFICATION_CODE": "We have sent you an email with a verification code."
            },
            "DISABLE_SYSTEM_EMAIL": {
                "DISABLE_CUSTOM_SERVICE_EMAIL": "Disable Custom Service Email",
                "SYSTEM_EMAILS_SEND": "System emails will be sent from default VSight service email.",
                "CANCEL": "Cancel",
                "DISABLE": "Disable"
            },
            "ALWAYS_ARCHIVE": {
                "AUTO_RECORD": "Automatically Record All Work Groups",
                "CHANGE_INDIVIDUALLY": "Change Work Group Record Behavior Individually",
                "AUTO_MESSAGE": "All work group sessions will be recorded automatically.",
                "INDIVIDUAL_MESSAGE": "You can change work group record behavior at individual work group pages.",
                "WARNING": "Changes on automatic video call record will be applied to subsequent sessions.",
                "CAUTION": "CAUTION: This is a Peer-to-Peer work group. Record unavailable for these work groups.",
                "CANCEL": "Cancel",
                "PROCEED": "Proceed",
                "CHANGE": "Change Individually"
            },
            "WHAT_IS_P2P": {
                "TITLE": "What is Peer-to-Peer",
                "BETWEEN_CLIENTS": "Clients send audio-video streams directly between each other.",
                "REDUCED_LATENCY": "Peer-to-Peer option offers the benefit of reduced latency.",
                "ARCHIVE_UNAVAILABLE": "Peer-to-Peer sessions cannot be recorded, because the connection is directly established between the peers involved in the session.",
                "CLOSE": "Close"
            },
            "ADD_EMAIL": {
                "TITLE": "Email required",
                "ADMIN": "You need to add all admin and co-admin email addresses from the user pages.",
                "ALL": "You need to add all email addresses from the user pages.",
                "GO_TO_PROFILE": "Go to profile",
                "USER_MAILS": "Please add the email addresses of the following users:",
                "CLOSE": "Close"
            },
            "TWO_FACTOR_MODAL": {
                "ENABLE_ADMIN": "Enable Admin Two Factor Authentication",
                "DISABLE_ADMIN": "Disable Admin Two Factor Authentication",
                "ENABLE_ALL": "Enable All Users Two Factor Authentication",
                "DISABLE_ALL": "Disable All Users Except Admin Two Factor Authentication",
                "VERIFICATION_SENDED": "We will send you an email with a verification code.",
                "VERIFICATION_CODE": "Verification Code",
                "CANCEL": "Cancel",
                "SEND_CODE": "Send Code",
                "PROCEED": "Proceed"
            },
            "WHITELABEL_SETTINGS": {
                "TITLE": "Whitelabel Settings",
                "SYSTEM_EMAIL_TITLE": "Customize system email",
                "SYSTEM_EMAIL_MESSAGE": "You can configure your service email from here.",
                "ENABLE": "Enable",
                "DISABLE": "Disable"
            },
            "WEBHOOKS": {
                "TITLE": "Webhooks",
                "NEW_WEBHOOK": "Add Webhook",
                "NO_WEBHOOK": "Webhook list is empty",
                "EVENT": "Event",
                "URL": "URL",
                "SAVE": "Save",
                "REMOVE": "Remove",
                "ERROR": "An error occurred.",
                "API_ERROR": "Test notification failed.",
                "ADD_WEBHOOK_MODAL": {
                    "TITLE": "Add Webhook",
                    "PLACEHOLDER": "https://",
                    "WARNING": "Test notification will be sent while adding a new webhook.",
                    "CANCEL": "Cancel",
                    "ADD": "Add",
                    "AUTH": "Auth",
                    "KEY": "Key",
                    "VALUE": "Value",
                    "NONE": "None",
                    "TOKEN_BASED_BODY": "Token based (on request body)",
                    "TOKEN_BASED_HEADER": "Token based (on header)",
                    "KEY_PLACEHOLDER1": "e.g., token",
                    "VALUE_PLACEHOLDER1": "e.g., eyJhbGci...",
                    "KEY_PLACEHOLDER2": "e.g., Authorization",
                    "VALUE_PLACEHOLDER2": "e.g., Bearer eyJhbGci...",
                    "EXAMPLE_NOTIFICATION": "Example Notification",
                    "SHOW_EXAMPLE": "Show Example Notification",
                    "FORM_WARNING": "Please fill all fields"
                },
                "REMOVE_WEBHOOK_MODAL": {
                    "TITLE": "Remove Webhook?",
                    "MESSAGE": "Are you sure you want to remove webhook?",
                    "CANCEL": "Cancel",
                    "REMOVE": "Remove"
                }
            },
            "TICKET_TYPES": {
                "TITLE": "Ticket Types",
                "NEW_TYPE": "Add Ticket Type",
                "NO_TYPE": "No ticket types defined",
                "LOADING": "Loading ticket types...",
                "ID": "ID",
                "NAME": "Name",
                "NAME_PLACEHOLDER": "Enter ticket type name",
                "REMOVE": "Remove",
                "SAVE": "Save Changes",
                "SAVING": "Saving...",
                "ERROR_LOADING": "Failed to load ticket types",
                "ERROR_SAVING": "Failed to save ticket types",
                "SUCCESS": "Ticket types saved successfully",
                "VALIDATION_ERROR": "Please enter a name for all ticket types",
                "DUPLICATE_ID_ERROR": "Duplicate ticket type names generate identical IDs. Please use unique names.",
                "REMOVE_CONFIRM": "Are you sure you want to remove this ticket type?",
                "REMOVE_TITLE": "Remove Ticket Type"
            },
            "PASSWORD_POLICY": {
                "TITLE": "Password Policy",
                "SPECIFY_RULE": "Specify your users' password rules",
                "MIN_LENGTH": "Minimum password length",
                "FOLLOWING_CRITERIAS": "Meets the following criterias",
                "SAVE": "SAVE",
                "SUCCESS": "Your password settings have been changed",
                "ERROR": "An error occurred.",
                "UPPERCASE": "Uppercase",
                "LOWERCASE": "Lowercase",
                "NUMBER": "Number",
                "SPECIAL": "Special"
            },
            "CONTACT_INFO": {
                "TITLE": "Contact Information",
                "NEW": "New Contact",
                "CONTACT": "Contact",
                "DEPARTMENT": "Department",
                "NAME": "Name",
                "EMAIL": "Email",
                "PHONE": "Phone Number",
                "DELETE": "Delete",
                "EDIT": "Edit",
                "CANCEL": "Cancel",
                "REVERT": "Revert",
                "DEP_REQ": "Department Required",
                "NAME_REQ": "Name Required",
                "EMAIL_REQ": "Email Required",
                "INVALID_EMAIL": "Invalid Email",
                "SAVE": "SAVE",
                "SUCCESS": "Contact information is updated successfully.",
                "FAILED": "Contact information update is failed."
            },
            "SYS_REQ": {
                "TITLE": "Hardware and Software Requirements",
                "ANDROID_TITLE": "Requirements for Android Devices",
                "IOS_TITLE": "Requirements for iOS Devices",
                "NETWORK_TITLE": "Network Requirements",
                "BROWSERS_TITLE": "Supported Browsers",
                "ANDROID_VERSION": "Android 5.0 or later",
                "ANDROID_RAM": "1.5 GB of RAM or higher",
                "ANDROID_CORE_SPEED": "Maximum Core speed 1.5 GHz or higher",
                "ANDROID_ARCORE": "In order to use AR+, your device needs to support ARCore. Devices that support ARCore can be found at this page: ",
                "ANDROID_ARCORE_DEVICE": "ARCore supported devices",
                "IOS_VERSION": "iOS 13 or later",
                "IOS_IPHONE": "iPhone 8 or newer",
                "IOS_IPAD": "iPad Pro 2017 or newer",
                "IOS_ARKIT": "In order to use AR+, your device needs to support ARkit. Devices that support ARkit can be found at this page: ",
                "IOS_ARKIT_DEVICE": "ARkit supported devices",
                "NETWORK_BODY": "An Internet connection with 350 Kbps download and upload speed is required to maintain a stable video connection but 1 Mbps download and upload speed with low latency is recommended to get better results.",
                "CHROME": "Google Chrome",
                "FIREFOX": "Mozilla Firefox",
                "SAFARI": "Safari (12 or later)",
                "EDGE": "Microsoft Edge (79 or later)"
            }
        },
        "STORAGE": {
            "TITLE": "Video Call Record Storage",
            "REMOTE_ASSISTANCE_STORAGE": "Remote Assistance Storage",
            "CONNECT_AZURE": "Connect to Azure",
            "DISCONNECT_AZURE": "Disconnect Azure",
            "SHARED_DEDICATED_SIZE": "You have {{dedicated}} GB Cloud Storage",
            "SHARED_DEDICATED_DELETE": "Once your storage is full, old video call records will be deleted",
            "SHARED_EXPIRE_TIME": "Your video call records will be stored for {{expire}} days",
            "SHARED_EXPIRE_DELETE": "After that expired, video call records will be deleted",
            "SHARED_UNLIMITED": "We provide you with unlimited, non-expiring storage capacity for all your video recordings.",
            "PRIVATE_STORAGE_MESSAGE": "You can connect the Azure Cloud Storage accont to {{appName}}.",
            "PRIVATE_STORAGE_EXPLANATION": "Video call records will be uploaded to your storage bucket.",
            "PRIVATE_NO_AZURE": "NO AZURE CLOUD STORAGE CONNECTED",
            "PRIVATE_AZURE": "AZURE CLOUD STORAGE CONNECTED",
            "PRIVATE_AZURE_NAME": "Account Name: {{account_name}}",
            "AZURE_INFO_LOADING": "Loading",
            "CHECK_AZURE_TEMPLATE": {
                "CONNECT_AZURE_CLOUD_STORAGE": "Connect to Azure Cloud Storage",
                "DISCONNECT_AZURE_CLOUD_STORAGE": "Disconnect Azure Cloud Storage",
                "CAUTION": "CAUTION: A video call record saving is currently running. Changing storage now may cause record loss.",
                "CANCEL": "Cancel",
                "CONNECT_ANYWAY": "Connect Anyway",
                "DISCONNECT_ANYWAY": "Disconnect Anyway"
            },
            "CONNECT_AZURE_TEMPLATE": {
                "CONNECT_AZURE_CLOUD_STORAGE": "Connect to Azure Cloud Storage",
                "ACCOUNT_NAME": "Account Name",
                "ACCOUNT_NAME_IS_REQUIRED": "Account name required.",
                "CONTAINER_NAME": "Container Name",
                "CONTAINER_NAME_IS_REQUIRED": "Container name required.",
                "ACCOUNT_KEY": "Account Key",
                "ACCOUNT_KEY_IS_REQUIRED": "Account key required.",
                "CANCEL": "Cancel",
                "CONNECT": "Connect"
            },
            "DISCONNECT_AZURE_MODAL": {
                "TITLE": "Disconnect Azure Cloud Storage",
                "MESSAGE": "Your Azure account will be disconnected.",
                "CAUTION": "CAUTION: If you disconnect this account, you cannot download the records that were saved on this Azure account using {{appName}} Admin Panel.",
                "CANCEL": "Cancel",
                "DISCONNECT": "Disconnect"
            },
            "ARCHIVE_STORAGE": {
                "ARCHIVE_UNAVAILABLE": "Video Call Record: Your licence doesn't contain this feature.",
                "PRIVATE_STORAGE_UNAVAILABLE": "Your licence does not contain the Azure Integration feature."
            },
            "WEBDAV_MESSAGE": "Video call records will be uploaded to your webdav account.",
            "MESSAGES": {
                "AZURE_CONNECTED": "Azure cloud storage connected.",
                "AZURE_DISCONNECTED": "Azure cloud storage disconnected.",
                "CANNOT_CONNECT": "Cannot connect Azure cloud storage.",
                "CANNOT_DISCONNECT": "Cannot disconnect Azure cloud storage."
            }
        },
        "ROOM": {
            "SIDEBAR" : {
                "CHAT_TITLE" : "Chat",
                "PARTICIPANTS_TITLE" : "Participants",
                "FILES_TITLE" : "Files",
                "SETTINGS_TITLE" : "Settings",
                "SHOW_TICKET": "Show Ticket",
                "ATTACH_TO_TICKET": "Attach to Ticket",
                "ATTACH_SESSION_TO_TICKET": "Attach Session to Ticket",
                "OPEN_WORKFLOW": "Open Workflows",
                "CHAT" : {
                    "SEE_TRANSLATION": "See Translation",
                    "SEE_ORIGINAL": "See Original",
                    "TRANSLATING": "Translating",
                    "FILE_SHARE" : {
                        "DRAG_HERE" : "Drag Files Here",
                        "UPLOAD_TITLE": "Upload Files",
                        "IMAGE": "Image",
                        "PDF": "PDF",
                        "3D_OBJECT": "3D Object",
                        "OTHER": "Other",
                        "MULTIPLE_OBJECTS": "We found multiple objects in your files. Please upload one object (with textures if available) at a time.",
                        "LARGER_THAN": "Larger than {{ megabytes }} MB",
                        "FILETYPE_PROHIBITED": "Filetype prohibited",
                        "START_UPLOAD": "UPLOAD",
                        "CANCEL_UPLOAD": "STOP",
                        "CLOSE_UPLOAD": "CLOSE",
                        "CANCEL_MODAL_TITLE": "Stop uploads?",
                        "CANCEL_MODAL_MESSAGE": "This will stop current uploads.",
                        "CANCEL_MODAL_CLOSE": "Cancel",
                        "CANCEL_MODAL_CANCEL": "Stop"
                    },
                    "DELETE_FILE_MODAL": {
                        "TITLE": "Delete File?",
                        "MESSAGE": "File will be deleted",
                        "CLOSE": "Close",
                        "DELETE": "Delete"
                    },
                    "FILE_DETAILS_MODAL": {
                        "TITLE": "File Details",
                        "FILENAME": "Filename",
                        "SIZE": "Size",
                        "TYPE": "Type",
                        "UPLOAD_TIME": "Upload Time",
                        "DOWNLOAD": "Download",
                        "CLOSE": "Close",
                        "FILECOUNT": "Total File Count"
                    },
                    "COLLABORATE": "Collaborate",
                    "CLOSE_COLLABORATION": "Close Collaboration",
                    "DOWNLOAD": "Download",
                    "DELETE": "Delete",
                    "DETAILS": "Details",
                    "SEND_TO_FILES": "Send to Files",
                    "FILE_DELETED": "File deleted",
                    "JOIN_ROOM" : "{{ owner_info }} joined the work group.",
                    "LEAVE_ROOM" : "{{ owner_info }} left the work group.",
                    "REACTION": "{{ owner_info }} sent a reaction.",
                    "REQUEST_SCREENSHOT": "{{ owner_info }} took a snapshot.",
                    "SHARE_SCREENSHOT" : "{{ owner_info }} shared a snapshot.",
                    "SAVED_COLLABORATION": "Collaboration saved",
                    "SHARE_IMAGE" : "{{ owner_info }} shared an image.",
                    "SHARE_PDF" : "{{ owner_info }} shared a PDF.",
                    "SHARE_OTHER" : "{{ owner_info }} shared a file.",
                    "SHARE_OBJECT" : "{{ owner_info }} shared a 3D object.",
                    "COLLABORATED" : "{{ owner_info }} started the collaboration.",
                    "TYPE_HERE" : "type here...",
                    "PLEASE_WAIT_OTHERS": "Please wait for other users to join.",
                    "DOWNLOAD_STARTED_SOON": "Download will start shortly",
                    "DOWNLOAD_FAILED": "Download failed",
                    "DOWNLOAD_OBJECT_NOT_SUPPORTED": "Download of this object is not supported yet.",
                    "DOWNLOAD_NOT_SUPPORTED": "This download is not supported yet.",
                    "CLOSE_PREV_COLLABORATION_TITLE": "Close current file-collaboration?",
                    "CLOSE_COLLABORATION_TITLE": "Close file-collaboration?",
                    "CLOSE_PREV_COLLABORATION_MESSAGE": "This will close the current file-collaboration and start a new one.",
                    "CLOSE_COLLABORATION_MESSAGE": "This will close the file-collaboration.",
                    "CLOSE_PREV_COLLABORATION_YES": "Proceed",
                    "CLOSE_PREV_COLLABORATION_NO": "Cancel",
                    "DISABLE_FOCUS_MODAL": {
                        "TITLE": "Open file-collaboration?",
                        "MESSAGE_AUTHORIZED": "A pinned window exists. Do you want to unpin it and open the file-collaboration?",
                        "MESSAGE_UNAUTHORIZED": "The file-collaboration cannot be opened, due to a pinned window.",
                        "CANCEL": "Cancel",
                        "CLOSE": "Close",
                        "PROCEED": "Proceed"
                    },
                    "CLOSE_ARPLUS_BEFORE_COLL": {
                        "TITLE": "Close AR+?",
                        "MESSAGE": "You need to close AR+, before you can open the collaboration. Are you sure you want to close AR+?",
                        "NO": "No",
                        "YES": "Yes"
                    }
                },
                "PARTICIPANTS": {
                    "HOST": "(Host)",
                    "LOWER_ALL_HANDS": "Lower All Hands",
                    "RAISED_HAND": "{{ name }} raised his hand.",
                    "DENIED_PUBLISH": "{{ name }} refused to join with video/audio.",
                    "PARTICIPANT_LIMIT_REACHED": "Video/audio communication participant limit reached.",
                    "CALLING": "Calling: {{ participants }}"
                },
                "FILES": {
                    "INFO_TEXT": "All expert and co-admins who have access to this work group can see and modify the files in this section",
                    "DOWNLOAD": "Download",
                    "SEND_TO_SESSION": "Send to session",
                    "DELETE": "Delete",
                    "UPLOAD_FILE": "Upload File",
                    "FILE_CONTENTS": "File Contents:",
                    "FILE_NAME": "File Name:",
                    "FILE_SIZE": "File Size:",
                    "TOTAL_SIZE": "Total Size:",
                    "DOWNLOAD_STARTED_SOON": "Download will be started soon.",
                    "DOWNLOAD_FAILED": "Download failed.",
                    "DELETE_MODAL": {
                        "TITLE_DELETE": "Delete file?",
                        "MESSAGE_DELETE": "Are you sure you want to delete this file?",
                        "CANCEL": "Cancel",
                        "DELETE": "Delete"
                    }
                },
                "SETTINGS": {
                    "MICROPHONE": "Microphone",
                    "CAMERA": "Camera",
                    "TRANSLATE_OTHERS_MSG_TO": "Translate Messages Of Others To:",
                    "TRANSLATE_MY_MSG_TO": "Translate My Messages To:",
                    "CREATE_GUEST_ACCESS": "Create Guest Access",
                    "GENERATING": "Generating",
                    "GUEST_ACCESS": "Guest Access",
                    "COPY_LINK": "Copy",
                    "LINK_COPIED": "Link copied to clipboard",
                    "LINK_GENERATED": "Join session link was generated",
                    "CANNOT_CREATE_GUEST_ACCESS": "Cannot create guest access.",
                    "NO_LINK_PERMISSION": "You don't have permission to create a guest access link. Please contact your admin.",
                    "SHARE": "Share",
                    "SHARE_LINK_VIA_SMS": "Share Link via SMS",
                    "SMS_SEND": "Link was sent via SMS",
                    "OPENING": "Opening",
                    "SEND": "Send",
                    "SMS_LIMIT_REACHED": "Sent SMS limit reached. Please contact your admin.",
                    "ERROR_OCCURED": "An error has occurred.",
                    "SMS_LICENSE_PERMISSION": "You don't have the permission to send SMS. Please contact your admin.",
                    "RESHARE": "You can share the link once per minute.",
                    "DIDNT_GET": "Did you not receive the link?",
                    "PHONE_NUMBERS": "Recently used phone numbers",
                    "RESEND": "Resend",
                    "CANCEL": "Cancel",
                    "CONNECT_VIA_FIELD_CODE": "Connect with the user via Field ID",
                    "CONNECT": "Connect",
                    "INVITATION_SENT": "The invitation has been sent to the user.",
                    "INVITATION_COULD_NOT_SENT": "The invitation could not be sent to the user.",
                    "FIELD_CODE": "Field ID"
                }
            }
        },
        "LICENSE_MODAL": {
            "TITLE": "Account Licence",
            "LOADING": "Loading",
            "START": "Start Date",
            "END": "End Date",
            "TYPE": "Licence Type",
            "CONCURRENT_LIMIT_ACCOUNT": "Concurrent User Limit in Account",
            "CONCURRENT_LIMIT_ROOM": "Max. Users in Work Group",
            "EXPERT_LIMIT": "Max. Experts",
            "CON_EXPERT_LIMIT": "Concurrent Expert Limit in Account",
            "UNLIMITED": "Unlimited",
            "LIMIT_VALUE": "{{ limit }}",
            "LIMIT2_VALUE": "{{ limit2 }}",
            "EXP_CON_LIMIT_VALUE": "{{ expert_concurrent_limit }}",
            "ROOM_LIMIT_VALUE": "{{ room_limit }}",
            "ARCHIVE": "Video Call Recording",
            "ARCHIVE_AVAILABLE": "Available",
            "ARCHIVE_UNAVAILABLE": "Unavailable",
            "CLOSE": "Close",
            "EXPERT_USER_BASED": "Expert User Based",
            "ROOM_LIMIT": "Limit of Work groups that can be created",
            "CONCURRENT_USER_BASED": "Concurrent User Based",
            "LIMIT": "Limit of Users per Session",
            "WORKFLOW_USER_LIMIT": "User Limit",
            "LIMIT2": "Limit of Experts that can be created",
            "EXPERT_CONCURRENT_LIMIT": "Limit of Experts that can log in simultaneously",
            "ALLOW_ARCHIVING": "Video Call Recording",
            "TRAININGLICENSES": "Academy Work Group Licence",
            "CONSUMED": "Consumed",
            "LICENCE_HOURS": "{{hours}} hour package"
        },
        "LICENCE-EXPIRED": "Your license has expired"
    },
    "MODALS": {
        "JOIN_MODAL": {
            "JOIN" : "JOIN",
            "CALL": "CALL",
            "CANCEL": "CANCEL",
            "MIRROR_VIDEO": "Mirror Video",
            "PREFERRED_RESOLUTION": "Preferred Resolution",
            "RESOLUTION_NOTE": "Note: If your device cannot support the resolution you requested, the next largest resolution will be used.",
            "CAM_MIC_PERM_REQUIRED": "Camera and microphone permission required",
            "CAM_MIC_PERM_DENIED": "Camera or microphone access denied",
            "CAM_MIC_CANT_ACCESS": "We can't access your camera or microphone",
            "JOIN_CAM_OFF": "Join with camera switched off",
            "JOIN_MIC_OFF": "Join with microphone switched off",
            "JOIN_CAM_MIC_OFF": "Join with camera and microphone switched off",
            "JOIN_NO_DEVICE": "Join with no camera and microphone",
            "ALLOW_ACCESS": "You need to allow access to your camera and microphone in your browser settings (After you grant access, you can still turn off your camera or microphone).",
            "TRY_AGAIN": "Try again/refresh the page and select 'Allow' when prompted by your browser."
        },
        "GET_EXPORT_MODAL": {
            "TITLE": "Get Session Export",
            "MESSAGE1": "Please enter your email address to receive the link to download the session export after the session ends.",
            "MESSAGE2": "The session export will include all <strong>chat messages</strong>, <strong>snapshots<strong/>, <strong>video call records</strong> and <strong>files</strong> shared in the session.",
            "EXPORT_NAME_NOT_LOCKED": "You can rename the export file by entering a customized file name instead.",
            "EXPORT_NAME_LOCKED": "You will be able to rename the export file as soon as the other user has completed the export.",
            "EXPORT_NAME_RENAMED": "Export file is renamed by this user:",
            "EXPORT_NAME_PLACEHOLDER": "Export Name",
            "NOTE": "Note: You can update your email address from the profile menu.",
            "OPEN_PROFILE": "Open profile",
            "EMAIL": "Email",
            "CLOSE": "Close",
            "SEND": "Send",
            "EXPORT_SUCCEEDED": "Session export will be sent after the session ends.",
            "ENDED_SESSION_EXPORT_SUCCEEDED": "Session export is sent.",
            "EXPORT_FAILED": "An error occurred."
        },
        "ALERT": {
            "TEXT": "Are you sure?",
            "CANCEL": "Cancel",
            "CONFIRM": "Delete",
            "CONTINUE": "Continue"
        },
        "IMAGE-EDITOR": {
            "TITLE": "Image Editor",
            "CANCEL": "Cancel",
            "SAVE": "Save",
            "CROP": "Crop"
        },
        "TEMPLATE": {
            "CREATE-STEP": "Create Step",
            "OPTIONS": {
                "TITLE": "Please select a template",
                "FULL": "Full Page",
                "VERTICAL": "Vertical Page",
                "HORIZONTAL": "Horizontal Page"
            },
            "CREATE": "Create",
            "CHANGE": "Change"
        },
        "WORKFLOW-USERS": {
            "TITLE": "Workflow Users",
            "USERS": "Users",
            "SELECTED": "Selected Users",
            "CLOSE": "Close",
            "SAVE": "Save",
            "LIMIT-FULL": "Workflow user limit is full"
        },
        "WORKFLOW-SHARING": {
            "TITLE": "Share Workflow with Child Accounts",
            "DESCRIPTION": "Select which child accounts can access this workflow.",
            "NOT_PARENT_ACCOUNT": "This account is not a parent account or has no child accounts.",
            "NO_CHILDREN": "No child accounts linked.",
            "CLOSE": "Close",
            "SAVE": "Save Sharing Settings",
            "SHARING_UPDATED": "Sharing settings updated successfully",
            "SHARING_ERROR": "Failed to update sharing settings"
        },
        "GENERATE-WORKFLOW": {
            "TITLE": "Create Automatic Workflow With AI",
            "PROMPT-TEXT": "Instantly create a workflow by providing a text description below. Our AI tool will automatically generate a step-by-step workflow with all the necessary content.",
            "CONFIRM-BUTTON-TEXT": "SUBMIT",
            "CANCEL-BUTTON-TEXT": "CANCEL",
            "INVALID-WORKFLOW-ERROR" : "Workflow cannot created using prompt",
            "PERMISSION-DENIED": "You do not have permission",
            "PROMPT-REQUIRED": "Prompt text not found",
            "INTERNAL-ERROR": "An error occurred"
        },
        "SIGNATURE": {
            "ADD-SIGNATURE": "Add Signature",
            "DRAW-SIGNATURE": "Draw your signature",
            "CLEAR": "Clear",
            "REQUIRED-NAME": "Name is required",
            "INSERT": "Insert",
            "TYPE-SIGNATURE": "Type in your signature",
            "USE-PHOTO": "Use a photo of your signature",
            "FULL-NAME": "Full name"
        },
        "WORKFLOW-NEW-LANGUAGE": {
            "ADD-LANGUAGE": "Add Language",
            "NEW-LANGUAGE": "You are about to add a new language to the workflow.Do you want to auto-translate all content from default language into the language you are adding? If you want to translate the content yourself, you can choose to copy all default content into new language and edit manually.",
            "AUTO-TRANSLATE": "Auto-translate",
            "COPY-CONTENT": "Copy content from default"
        },
        "DEFAULT-LANGUAGE": {
            "PRIMARY-LANGUAGE": "The language you choose as default will be the primary language that users will view this workflow on their devices. You can make a multi-language workflow by adding additional languages in the editor after you have created the workflow.",
            "DEFAULT-LANGUAGE": "Default language of this workflow",
            "CREATE": "CREATE"
        },
        "USER-DEFAULT-LANGUAGE": {
            "PREFFERED-LANGUAGE": "Choose the preferred language you would like to view workflows content."
        },
        "TABLE-CELL": {
            "AT-LEAST": "This field should be at least {{min}}",
            "AT-MOST": "This field should be at most {{max}}"
        },
        "OPEN-AI": {
            "DESCRIBE": "Describe the workflow you’d like to create"
        }
    },
    "EXTERNALS": {
        "AD_LOGIN": {
            "MESSAGE": "An error has occurred."
        },
        "AD_ERROR": {
            "ACCOUNT_NOT_FOUND": "Your account is not connected to Azure AD.",
            "PERMISSION_DENIED": "You don't have the permission to see this page.",
            "INTERNAL_ERROR": "An error has occurred.",
            "CONTACT_MAIL": "Please contact <strong>{{ contactMail }}</strong>."
        }
    },
    "NOT-FOUND": {
        "TEXT": "We are sorry, the page you requested cannot be found.",
        "INFORM": "The URL may be misspelled or the page you are looking for is no longer available."
    },
    "ERRORS": {
        "UPLOAD-ERROR": "Upload Error",
        "ERROR": "Error Occured"
    },
    "WEB-VERSION": {
        "TASK-TO-COMPLETE": "Tasks to complete",
        "ESTIMATED-DURATION": "Estimated Duration",
        "START": "START",
        "PREVIOUS": "Previous",
        "NEXT": "Next",
        "SUBMIT": "Submit",
        "SUCCESS-SUBMIT-MESSAGE": "Your workflow has been submitted successfully!",
        "SUCCESS-SAVE-MESSAGE": "Your workflow has been saved successfully!",
        "SAVE-AS-DRAFT": "Save as a Draft",
        "CLOSE-WORKFLOW-WARNING-TEXT": "Are you sure you want to close this workflow. Your changes will be discarded.",
        "CONTINUE-WORKFLOW-TEXT-MESSAGE": "You started this workflow already. Do you want to continue, or start over?",
        "CONTINUE": "Continue",
        "START-OVER": "START OVER",
        "INCOMPLETE": "Incomplete",
        "SUBMITTED": "Submitted",
        "VERSION": "Version",
        "LAST-SAVED": "Last Saved",
        "PUBLISHED-AT": "Published at",
        "STATUS": "Status",
        "SELECT": "Select",
        "SEARCH": "Search",
        "SAVE": "Save",
        "CANCEL": "Cancel",
        "CLEAR": "CLEAR"
    },
    "Number": "Number",
    "Text": "Text",
    "Multiple Choice": "Multiple Choice",
    "Checkboxes": "Checkboxes",
    "Date": "Date",
    "Time": "Time",
    "File Upload": "File Upload",
    "Capture Image": "Capture Image",
    "Capture Video": "Capture Video",
    "PPE": "PPE",
    "QR": "QR",
    "Contains": "Contains",
    "Does not contain": "Does not contain",
    "Is empty": "Is empty",
    "Is not empty": "Is not empty",
    "Equals": "Equals",
    "Not Equals": "Is not equal",
    "Greater than": "Greater than",
    "Less than": "Less than",
    "Greater or Equal": "Greater or Equal",
    "Less or Equal": "Less or Equal",
    "Is": "Is",
    "Is not": "Is not",
    "Starts with": "Starts with",
    "Ends with": "Ends with",
    "Is before": "Is before",
    "Is after": "Is after",
    "Is between": "Is between",
    "Is not between": "Is not between",
    "Is detected": "Is detected",
    "Is not detected": "Is not detected",
    "input": "TEXT INPUT",
    "number": "NUMBER INPUT",
    "datepicker": "DATEPICKER",
    "multicheckbox": "CHECKBOX",
    "radio": "RADIO BUTTON",
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Items per page:",
        "NEXT_PAGE": "Next page",
        "PREVIOUS_PAGE": "Previous page",
        "FIRST_PAGE": "First page",
        "LAST_PAGE": "Last page",
        "RANGE": "{{start}} – {{end}} of {{length}}",
        "RANGE_ZERO": "0 of {{length}}"
    }
}